import React, { Component, Fragment } from "react";
import ReactWebChat from "botframework-webchat";
//import BookingApp from "./BookingApp";
import "./ChatWindow.css";
import "./bootstrap.min.css";
import "./ChatWindowNew.css";
import "./ChatWindowLayout/ChatWindowSuggest.css";
import WebViewExtension, {
  WEB_VIEW_EXT_ID,
} from "./Extensions/WebViewExtension/WebViewExtension";
import WebViewExternalExtension, {
  WEB_VIEW_EX_EXT_ID,
} from "./Extensions/WebViewExternalExtension/WebViewExternalExtension";
import ChatSuggestionExtension, {
  CHAT_SUGGESTION_EXT_ID,
} from "./Extensions/ChatSuggestionExtension/ChatSuggestionExtension";
import PersistentMenu from "./ChatComponent/PersistentMenu";
import PropertyPopup from "./ChatComponent/PropertyPopup";
import { FormattedMessage, IntlProvider } from "react-intl";
import AppLocale from "./lang";
import CookiePopup from "./ChatComponent/CookiePopup";
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Row,
  Col,
  Input,
  FormGroup,
  Label,
  Form,
  Button,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import BookingApp from "./BookingApp";
import ChatWindowTypingIndicator from "./ChatWindowTypingIndicator";
import ChatWindowParticipantTagger from "./ChatWindowParticipantTagger";
import ChatWindowCardAction from "./ChatWindowCardAction";
import Translate from "./helpers/Translate";
import { AttachmentMiddleware } from "./Extensions/AttachmentMiddleware";
import IntlMessages from "./helpers/IntlMessages";
import ReactHtmlParser, { processNodes, htmlparser2 } from "react-html-parser";
import CheckAvailablity from "./ChatComponent/CheckAvailablity";
import ServicePopup from "./ChatComponent/ServicePopup";
import FeedbackPopup from "./ChatComponent/FeedbackPopup";
import AutoCompleteExtension, {
  CHAT_AUTOCOMPLETE_EXT_ID,
} from "./Extensions/AutoCompleteExtension/AutoCompleteExtension";
import ThumbFeedback from "./ChatComponent/ThumbFeedback";
import RestartConversation from "./ChatWindowLayout/RestartConversation";
import CaseFormPopup from "./ChatComponent/CaseFormPopup";
import SalesForceActionPopup from "./ChatComponent/SalesForceActionPopup";
const publicIp = require("public-ip");
const TRANSLATE_URL = process.env.REACT_APP_API_URL + "/google-translate";
const ANALYTICS_URL = process.env.REACT_APP_API_URL + "/google-analytics";
const VISITOR_URL = process.env.REACT_APP_API_URL + "/visitors";
const ADDLINK_URL = process.env.REACT_APP_API_URL + "/links";
const SERVICES_URL = process.env.REACT_APP_API_URL + "/searchallservice";
const LEAVE_FEEDBACK = process.env.REACT_APP_API_URL + "/save-leavefeedback";
const BMB_GROUP_URL = process.env.REACT_APP_API_URL + "/group";
const myma_logo = "/res/myma_ai.png";
const myma_logo_greyscale = "/res/myma_greyscale.png";
const { getChatHistoryForAgent } = require("./ChatStore");

const styleOptions = {
  backgroundColor: "#e9eef4",
  bubbleBorderRadius: 8,
  bubbleTextColor: "#353f48",
  bubbleBackground: "#fff",
  bubbleFromUserBorderRadius: 8,
  bubbleFromUserBackground: "#dfcf92",
  bubbleFromUserTextColor: "#353f48",
  sendBoxTextColor: "#000",
  sendBoxBorderTop: "solid 1px #fff",
  sendBoxBorderBottom: "",
  sendBoxButtonColor: "#767676",
  sendBoxButtonColorOnFocus: "#333",
  sendBoxButtonColorOnHover: "#333",
  sendBoxPlaceholderColor: "#767676",
  paddingWide: 20,
  hideUploadButton: true,
  timestampColor: "#767676",
  sendBoxBackground: "#fff",
  bubbleBorderColor: "#E6E6E6",
  bubbleFromUserBorderColor: "#E6E6E6",
  suggestedActionLayout: "stacked",
  suggestedActionHeight: 30,
  suggestedActionBorderRadius: "50vh",
  suggestedActionBorderWidth: 0,
  suggestedActionBackground: "#fff",
  suggestedActionTextColor: "#353f48",
  sendBoxTextWrap: true,
  sendBoxMaxHeight: 100,
};

const localeOptions = [
  { id: "en", name: "English", desc: "English", code: "en", locale: "en" },
  { id: "hi", name: "Hindi", desc: "हिंदी", code: "hi", locale: "hi" },
  {
    id: "id",
    name: "Indonesian",
    desc: "bahasa Indonesia",
    code: "id",
    locale: "id",
  },
  { id: "es", name: "Spanish", desc: "Español", code: "es", locale: "es" },
  { id: "fr", name: "French", desc: "français", code: "fr", locale: "fr" },
  { id: "de", name: "German", desc: "Deutsche", code: "de", locale: "de" },
  { id: "zh", name: "Chinese", desc: "简体中文", code: "ZH-簡", locale: "zh" },
  {
    id: "vi",
    name: "Vietnamese",
    desc: "Tiếng Việt",
    code: "vi",
    locale: "vi",
  },
  { id: "th", name: "Thai", desc: "ไทย", code: "th", locale: "th" },
  { id: "ja", name: "Japanese", desc: "日本語", code: "ja", locale: "ja" },
  {
    id: "zh-TW",
    name: "Chinese (Traditional)",
    desc: "繁體中文",
    code: "ZH-繁",
    locale: "hk",
  },
  {
    id: "tl",
    name: "Tagalog (Filipino)",
    desc: "Tagalog (Filipino)",
    code: "tl",
    locale: "tl",
  },
  { id: "af", name: "Afrikaans", desc: "Afrikaans", code: "af", locale: "af" },
  { id: "ko", name: "Korean", desc: "한국어", code: "ko", locale: "ko" },
  { id: "mi", name: "Maori", desc: "Maori", code: "mi", locale: "mi" },
  { id: "ar", name: "Arabic", desc: "عربي", code: "ar", locale: "ar" },
  { id: "ru", name: "Russian", desc: "Русский", code: "ru", locale: "ru" },
  { id: "fi", name: "Finnish", desc: "Suomalainen", code: "fi", locale: "fi" },
];

export default class ChatWindow extends Component {
  constructor(props) {
    super(props);

    // Ensure callback is defined before tagger is created
    this.handleMultipleDislikesTriggered = false;
    this.handleSingleDislike = () => {
      // Raise event on directline for single dislike
      if (
        this.props.bookingApp &&
        this.props.bookingApp.callbacks &&
        typeof this.props.bookingApp.callbacks.getStore === "function"
      ) {
        this.props.bookingApp.callbacks.getStore().dispatch({
          type: "WEB_CHAT/SEND_EVENT",
          payload: {
            name: "query",
            value: {},
          },
        });
      }
    };
    this.handleMultipleDislikes = async () => {
      if (!this.handleMultipleDislikesTriggered) {
        // 1. Get chat history
        this.setState({ caseFormPrefillLoading: true });
        let chatHistory = "";
        try {
          // Try to get store from props or fallback
          let storeState = null;
          if (
            this.props.store &&
            typeof this.props.store.getState === "function"
          ) {
            storeState = this.props.store.getState();
          } else if (
            this.props.bookingApp &&
            this.props.bookingApp.callbacks &&
            typeof this.props.bookingApp.callbacks.getStore === "function"
          ) {
            storeState = this.props.bookingApp.callbacks.getStore().getState();
          }
          if (storeState) {
            chatHistory = getChatHistoryForAgent(storeState);
          }
        } catch (e) {
          console.error("Failed to get chat history for case data", e);
        }

        // 2. Call AI fetch case data API
        let aiCaseData = null;
        try {
          const resp = await fetch(
            `${process.env.REACT_APP_PARTNER_URL}/salesforce/ai-classify-case`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ conversationLogs: chatHistory }),
            },
          );
          if (resp.ok) {
            aiCaseData = await resp.json();
          }
        } catch (e) {
          console.error("Failed to fetch AI case data", e);
        }

        // 3. Prefill CaseFormPopup fields if response present
        if (aiCaseData && aiCaseData.arguments) {
          let args = {};
          try {
            args = JSON.parse(aiCaseData.arguments);
          } catch (e) {
            console.error("Failed to parse AI case data arguments", e);
          }

          const priority =
            aiCaseData.priority || aiCaseData.priority === null || "P4";
          const impact = aiCaseData.impact || aiCaseData.impact === null || "L";

          const prefillObj = {
            system: aiCaseData.system || "",
            scenario: aiCaseData.scenario || "",
            topic: aiCaseData.topic || "",
            subject: aiCaseData.subject || "",
            description: aiCaseData.case_description || "",
          };

          // Determine which popup to show
          let openSimpleAction = true;
          if (priority === "P4") {
            openSimpleAction = false;
          } else if (priority === "P3" && impact !== "H") {
            openSimpleAction = false;
          }

          this.props.bookingApp.callbacks.getStore().dispatch({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "webchat/salesforcecase",
              value: {
                allowChat: openSimpleAction,
              },
            },
          });
          //openSimpleAction = true;

          // if (openSimpleAction) {
          //   this.setState({
          //     //open_simple_action_popup: true,
          //     simpleActionPrefill: prefillObj,
          //     caseFormPrefillLoading: false,
          //   });
          // } else {
          //   if (!this.state.open_case_form_popup) {
          //     this._pendingCaseFormPrefill = prefillObj;
          //     this.setState({
          //       //open_case_form_popup: true,
          //       caseFormPrefillLoading: false,
          //     });
          //   } else if (
          //     this.caseFormPopupRef &&
          //     typeof this.caseFormPopupRef.prefillFields === "function"
          //   ) {
          //     this.setState({ caseFormPrefillLoading: false });
          //     await this.caseFormPopupRef.prefillFields(prefillObj);
          //   } else {
          //     this._pendingCaseFormPrefill = prefillObj;
          //   }
          // }
        }
        // else {
        //   this.setState({
        //     open_case_form_popup: true,
        //     caseFormPrefillLoading: false,
        //   });
        // }
        this.setState({
          caseFormPrefillLoading: false,
        });
        this.handleMultipleDislikesTriggered = true;
      }
    };

    this.props.bookingApp.callbacks.close = () => {
      this.props.bookingApp.open = false;
      this.forceUpdate();
    };
    this.props.setBubbleToShrinkIn();
    localStorage.setItem(this.props.language_state_store, this.props.lang);
    this.state = {
      ask_close: false,
      menu_open: false,
      ask_bot_hide: false,
      language: this.props.lang,
      languageCode: "",
      langLocale: "",
      visitorPopupState: true,
      googleAnalytics: {},
      name: "",
      email: "",
      phoneNumber: "",
      firstName: "",
      lastName: "",
      zipCode: "",
      consentGiven: false,
      languageOptions: localeOptions.sort(this.dynamicSort("name")),
      persistentMenuData: [],
      open_language_popup: false,
      open_property_popup: false,
      open_availblity_popup: false,
      open_service_popup: false,
      open_case_form_popup: false,
      open_ZChatfeedback_popup: false,
      bubble_type: "",
      availblityData: null,
      zChatfeedbackData: null,
      isServiceAvailable: false,
      isButtonDisable: false,
      leaveFeedbackMessage: "",
      endChat: false,
      isOpenModal: false,
      modalContent: "",
      isCookiesHide: false,
      open_thumb_feedback: false,
      formSettings: null,
      visitorSettings: null,
      inactivePopUpWarning: null,
      inactivePopupSession: null,
      caseFormPrefillLoading: false,
      showTransferModal: false,
      showTransferLoader: false,
    };

    this.visitorPopupRef = React.createRef();
    this.caseFormPopupRef = React.createRef();

    this.state.confirm_cookies =
      localStorage.getItem(this.props.cookies_state_store) !== "yes";

    this.hide_bot_confirm = () => {
      this.setState({ ask_bot_hide: false });
      this.props.hideBot();
    };
    this.close_bot_ask_hide = () => {
      this.setState({ ask_bot_hide: false });
      this.props.onClosed();
    };
    this.end_clicked = () => {
      this.setState({ ask_close: true });
      this.setState({ menu_open: false });
      if (this.props.messenger === true) {
        this.props.bot_restartClick();
      }
    };
    this.menu_popup_open = () => {
      this.setState({ menu_open: true });
      this.setState({ ask_close: false });
    };
    this.menu_popup_Close = () => {
      this.setState({ menu_open: false });
    };

    this.handleTransferModalOk = () => {
      this.setState({ showTransferModal: false });
      this.close_confirmed();
    };
    this.handleStartChat = async () => {
      this.setState({ showTransferLoader: true });
      let chatHistory = "";
      try {
        // Try to get store from props or fallback
        let storeState = null;
        if (
          this.props.store &&
          typeof this.props.store.getState === "function"
        ) {
          storeState = this.props.store.getState();
        } else if (
          this.props.bookingApp &&
          this.props.bookingApp.callbacks &&
          typeof this.props.bookingApp.callbacks.getStore === "function"
        ) {
          storeState = this.props.bookingApp.callbacks.getStore().getState();
        }
        if (storeState) {
          chatHistory = getChatHistoryForAgent(storeState);
        }
      } catch (e) {
        console.error("Failed to get chat history for case data", e);
      }
      const caseBody = {
        AccountId: this.props.prechatdata?.accountId,
        ContactId: this.props.prechatdata?.contactId,
        GroupId: this.props.gid,
        ConversationId: this.props.directline.conversationId,
        conversationLogs: chatHistory,
      };
      // Print body as JSON string
      console.log(JSON.stringify(caseBody));
      try {
        const resp = await fetch(
          `${process.env.REACT_APP_PARTNER_URL}/salesforce/chat-case`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(caseBody),
          },
        );
        const data = await resp.json();
        console.log("Case creation response:", data);

        const detail = {
          chatSummary: data.chatSummary || "",
          caseId: data.caseId || "",
        };
        console.log("Dispatching handover_to_salesforce with detail:", detail);

        window.parent.parent.postMessage(
          {
            type: "handover_to_salesforce",
            detail,
          },
          "*",
        );

        const body = {
          GroupId: this.props.gid,
          ConversationId: this.props.directline.conversationId,
        };

        await fetch(
          `${process.env.REACT_APP_PARTNER_URL}/salesforce/transfer-chat`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          },
        );
      } catch (e) {
        console.error("Failed to get chat history for case data", e);
      }
      this.setState({ showTransferLoader: false, showTransferModal: true });
    };

    this.close_confirmed = () => {
      if (this.props.inZenDesk) {
        this.setState({
          ask_close: false,
          open_ZChatfeedback_popup: true,
          endChat: true,
        });
      } else {
        this.setState({ ask_close: false });
        this.props.endClicked();
      }
    };
    this.close_language_popup = () => {
      this.setState({ open_language_popup: false });
    };
    this.open_language_popup = () => {
      this.setState({ open_language_popup: true });
    };
    this.close_property_popup = () => {
      this.setState({ open_property_popup: false });
    };
    this.close_service_popup = () => {
      this.setState({ open_service_popup: false });
    };
    // Reset the multiple dislikes trigger when case form popup is closed
    this.close_case_form_popup = () => {
      this.setState({ open_case_form_popup: false });
      this.setState({
        open_simple_action_popup: false,
        caseFormPrefillLoading: false,
      });
      this.handleMultipleDislikesTriggered = false;
    };

    this.close_case_loader = () => {
      this.setState({ caseFormPrefillLoading: false });
    };

    this.openCaseForm = (prefill) => {
      this.setState({
        open_case_form_popup: true,
        caseFormPrefillLoading: true,
      });
    };

    this.OpenServicePopUp = () => {
      this.setState({ open_service_popup: true });
    };
    this.popupclose_confirmed = () => {
      this.setState({ ask_close: false });
      this.props.closeClicked();
    };
    this.refresh = () => {
      this.props.refreshClicked();
    };
    this.close_cancel = () => {
      this.setState({ ask_close: false });
      this.props.restartIconclick();
    };
    this.close_clicked = () => {
      this.setState({ ask_bot_hide: true });
      //this.props.onClosed();
    };
    this.close_cardapp = () => {
      this.setState({ card_app: undefined });
    };
    this.close_roomapp = () => {
      this.setState({ room_app: undefined });
    };
    this.cookies_understood = () => {
      // localStorage.setItem(this.props.cookies_state_store, "yes");
      // this.setState({ confirm_cookies: false });
      this.setState({ isCookiesHide: true });
    };
    this.availblityForm = (data) => {
      this.setState({ open_availblity_popup: true, availblityData: data });
    };
    this.closeAvailblityForm = () => {
      this.setState({ open_availblity_popup: false });
      this.props.setAvailblity(undefined);
    };

    this.setZchatFeedback = (data) => {
      this.setState({
        open_ZChatfeedback_popup: false,
        zChatfeedbackData: data,
      });
      this.props.sendFeedbackZenDeskChat(data, this.state.endChat);
    };

    this.cookies_details = (cookiesURL) => {
      this.addLinks(cookiesURL);
      if (window.parent) {
        window.parent.postMessage("openUrl:" + cookiesURL + "", "*");
      } else {
        window.location = cookiesURL;
      }
    };
    this.set_thumb_feedback_open = (val) => {
      this.setState({ open_thumb_feedback: val });
    };
    this.bob_site = (poweredByURL) => {
      this.addLinks(poweredByURL);
      if (window.parent) {
        window.parent.postMessage("openUrl:" + poweredByURL + "", "*");
      } else {
        window.location = poweredByURL;
      }
    };

    this.movetotop = () => {
      var els = document.getElementsByClassName(
        "webchat__basic-transcript__scrollable",
      );
      for (var el of els) {
        el.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    this.save_visitor = async (event) => {
      event.preventDefault();
      var user = {
        iid: this.props.iid,
        gid: this.props.gid,
        pid: this.props.pid,
        name: this.state.name,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        zipCode: this.state.zipCode,
        email: this.state.email,
        phoneNumber: this.state.phoneNumber,
        consentGiven: this.state.consentGiven,
      };
      this.setState({ visitorPopupState: false, isButtonDisable: true });
      const req = await fetch(`${VISITOR_URL}/${this.props.vid}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: user,
        }),
      });

      localStorage.setItem(
        this.props.visitor_state_store,
        JSON.stringify(user),
      );
    };

    this.addLinks = async (link) => {
      const req = await fetch(`${ADDLINK_URL}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.props.directline.conversationId,
          groupId: this.props.gid,
          link: link,
        }),
      });
    };

    this.closeMessger = async () => {
      if (window.parent) {
        window.parent.postMessage("closemessenger", "*");
      }
    };
    this.openBooknowUrl = (value) => {
      if (window.parent) {
        window.parent.postMessage("openUrl:" + value + "", "*");
      }
    };
    // Adds bot/user tags and icon to conversation blocks
    let tagger = new ChatWindowParticipantTagger(
      this.props.botSettings.assistantDetails,
      this.props.botSettings.urls.icon,
      this.props.gid,
      this.props.iid,
      this.props.mobile,
      this.handleMultipleDislikes, // callback for multiple dislikes
      this.handleSingleDislike, // callback for single dislike
    );
    tagger.start();
  }

  createCssRules() {
  const fontName = this.props.websiteFontName || "sans-serif";
  const fontLink = this.props.websiteFontLink;

  let styleTag = document.getElementById("font-style");

  if (!styleTag) {
    styleTag = document.createElement("style");
    styleTag.id = "font-style";
    document.head.appendChild(styleTag);
  }

  let fontFace = "";
  if (fontLink) {
    fontFace = `
      @font-face {
        font-family: ${fontName};
        src: url('${fontLink}') format('woff');
        font-display: swap;
      }
    `;
  }

  styleTag.innerHTML = `
    ${fontFace}

    body,
    .chat_window,
    .ac-textBlock,
    .markdown,
    .plain,
    .webchat__send-box-text-box__text-area,
    .webchat__stacked-layout__status span span {
      font-family: ${fontName} !important;
    }
  `;
    let intervalId = setInterval(() => {
      let sendButtonDiv = document.getElementsByClassName(
        "webchat__icon-button",
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_resize i{
          color:${this.props.botSettings.colours.closeIcon} !important;
        }
        `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_resize i:hover{
          color:${this.props.botSettings.colours.closeIconHover} !important;
        }
        `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_end svg {
            fill: ${this.props.botSettings.colours.closeIcon} !important;
        }
        `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_end svg:hover {
          fill: ${this.props.botSettings.colours.closeIconHover} !important;
        }
         `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .header_icon svg {
            fill: ${this.props.botSettings.colours.closeIcon} !important;
        }
        `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .header_icon svg:hover {
          fill: ${this.props.botSettings.colours.closeIconHover} !important;
        }
         `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_close svg {
            fill: ${this.props.botSettings.colours.minimizeIcon} !important;
        }
        `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_close svg:hover {
          fill: ${this.props.botSettings.colours.minimizeIconHover} !important;
        }
         `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_language svg {
          fill: ${this.props.botSettings.colours.minimizeIcon} !important;
        }
         `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_btn_language svg:hover {
          fill: ${this.props.botSettings.colours.minimizeIconHover} !important;
        }
         `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_menuitem svg {
            fill: ${this.props.botSettings.colours.minimizeIcon} !important;
        }
        `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
        .chat_header_menuitem svg:hover {
          fill: ${this.props.botSettings.colours.minimizeIconHover} !important;
        }
         `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
         .webchat__send-icon {
            opacity:1;
           fill: ${
             this.props.isSuggestBot === true
               ? this.props.botSettings.colours.headerText
               : this.props.botSettings.colours.sendIcon
           } !important;
           cursor: pointer;
         }
          `,
        0,
      );
      document.styleSheets[0].insertRule(
        `
          .webchat__send-icon:hover {
           fill: ${
             this.props.isSuggestBot === true
               ? this.props.botSettings.colours.headerText
               : this.props.botSettings.colours.sendIcon
           } !important;
            
          }
           `,
        0,
      );
      document.styleSheets[0].insertRule(
        `.main {
            margin-left: 13px;
            margin-right: 13px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          }`,
        0,
      );
      document.styleSheets[0].insertRule(
        `
          .webchat__basic-transcript__transcript {
              padding-top: ${
                this.props.mobile === "true"
                  ? "3.2em !important"
                  : "0.2em !important"
              };
      }`,
        0,
      );
      document.styleSheets[0].insertRule(
        `.webchat__send-box-text-box__text-area{font-family: ${this.props.websiteFont}!important;}`,
        0,
      );

      document.styleSheets[0].insertRule(
        `.webchat__stacked-layout__status span span{font-family: ${this.props.websiteFont}!important;}`,
        0,
      );
      if (this.props.isSuggestBot === true) {
        document.styleSheets[0].insertRule(
          `.restartChat-button {
            color:${this.props.botSettings.colours.headerText} !important;
            background-color:${this.props.botSettings.colours.header} !important;
            }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `.restartChat-button:hover {
            color:${this.props.botSettings.colours.header} !important;
            background-color:${this.props.botSettings.colours.headerText} !important;
            }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `
            .chat_header_btn_close_fullview svg{
              fill:${
                this.props.botSettings.colours.headerText !== null
                  ? this.props.botSettings.colours.headerText
                  : "#FFF"
              }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `.webchat__send-box-text-box{padding-left:20px !important;}`,
          0,
        );

        document.styleSheets[0].insertRule(
          `.react-film__filmstrip {
                scrollbar-width: thin !important;
                margin-bottom:0px !important
            }`,
          0,
        );
        document.styleSheets[0].insertRule(
          ` 
        .feed-left-message {
            margin-left:28rem
        }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `.feed-left-attachment {
            margin-left: 13rem;
            transform: translate(0%, -2.2rem) !important;
        }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `.feed-left-attachment-carousel{ margin-left: 11rem !important;}`,
          0,
        );
        if (this.props.mobile !== "true") {
          document.styleSheets[0].insertRule(
            `div.ac-textBlock { font-size: 1.3rem !important; }`,
            0,
          );
          document.styleSheets[0].insertRule(
            `.webchat__bubble__content p{
            font-size: 1.3rem !important;
          }
          `,
            0,
          );
        }
        document.styleSheets[0].insertRule(
          `.thumb-feedback {
          height: 400px !important;
          bottom: 107px !important;
          width: 409px  !important;
          left: 40% !important;
          right: 35% !important;
      }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `.herocard-button{font-size:17px !important}`,
          0,
        );
        document.styleSheets[0].insertRule(
          `
        .herocard-image {
          width: 100%  !important;
          margin-left: -3px  !important;}`,
          0,
        );
        document.styleSheets[0].insertRule(
          `
          .herocard-container {
            width: 100% !important;
        }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `
        .webchat__suggested-actions{
            position: absolute;
            bottom: ${this.props.mobile !== "true" ? "120px" : "95px"};
            left: ${this.props.mobile !== "true" ? "30%" : "0%"};
            right: ${this.props.mobile !== "true" ? "30%" : "0%"};
        }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `
        .header-fullview{ 
          background-color:${this.props.botSettings.colours.header} !important;
          color:${this.props.botSettings.colours.headerText} !important;
        }`,
          0,
        );
        document.styleSheets[0].insertRule(
          `
        .clickbooknow{
          background-color:${this.props.botSettings.colours.headerText} !important;
          color:${this.props.botSettings.colours.header} !important;
          border-color:${this.props.botSettings.colours.headerText} !important;
        }`,
          0,
        );
      } else {
        document.styleSheets[0].insertRule(
          `.mic-icon{ margin-top: 0px !important;}`,
          0,
        );
      }
      if (this.props.messengerSettings?.widgetLayout === "Square Edges") {
        document.styleSheets[0].insertRule(
          `
          .form-control,.availablity_button,
          .cancelchat_button,.Calendar,.feedback-btn-color,
          .endchat_button
          {border-radius:0px !important}
          `,
          0,
        );
        document.styleSheets[0].insertRule(
          `.menu_popup, .endchat_popup, .feedback_popup{border-radius:0px !important}`,
          0,
        );
      }
      // if (sendButtonDiv.length !== 0) {
      //   sendButtonDiv[0].innerHTML =
      //     "<svg version='1.1' id='Layer_1' class='webchat__send-icon' xmlns='http://www.w3.org/2000/svg' " +
      //     "xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 122.88 116.6' " +
      //     "style='enable-background:new 0 0 122.88 116.6;margin-right: 10px;  width: 25px;'" +
      //     "xml:space='preserve'><g><path d='M24.44,0h74.01c6.68,0,12.77,2.75,17.19,7.17c4.47,4.47,7.24,10.65,7.24,17.45v67.35c0,6.8-2.78,12.98-7.25,17.45 c-4.42,4.42-10.51,7.17-17.19,7.17H24.44c-6.68,0-12.77-2.75-17.19-7.17C2.77,104.96,0,98.78,0,91.98V24.62 c0-6.81,2.77-12.99,7.24-17.45C11.67,2.75,17.75,0,24.44,0L24.44,0z M64.51,39.22v28.33c0,0.85-0.34,1.62-0.9,2.17 c-0.56,0.56-1.33,0.9-2.17,0.9c-0.85,0-1.62-0.34-2.17-0.9c-0.56-0.56-0.9-1.32-0.9-2.17V39.22l-10.92,9.53 c-0.63,0.55-1.43,0.8-2.21,0.76c-0.79-0.05-1.55-0.39-2.12-1.02c-0.56-0.63-0.81-1.43-0.77-2.21c0.05-0.78,0.39-1.54,1.02-2.1 l16.04-14c0.59-0.52,1.33-0.77,2.06-0.77c0.73,0.01,1.46,0.28,2.02,0.8l16.03,14c0.61,0.56,0.95,1.31,1,2.08 c0.05,0.78-0.21,1.57-0.77,2.2l-0.02,0.02c-0.56,0.62-1.32,0.95-2.09,1h-0.01c-0.78,0.04-1.58-0.21-2.21-0.77L64.51,39.22 L64.51,39.22z M4.93,82.85c0.85,3.45,2.55,6.55,4.83,9.01c3.36,3.62,7.99,5.87,13.1,5.87h77.17c0.21,0,0.41,0,0.62-0.01l1.25-0.09 c4.36-0.47,8.29-2.6,11.23-5.77c2.28-2.46,3.97-5.55,4.83-9V24.62c0-5.28-2.17-10.09-5.67-13.58c-3.54-3.54-8.44-5.74-13.84-5.74 H24.44c-5.4,0-10.3,2.2-13.84,5.74c-3.49,3.49-5.66,8.3-5.66,13.58V82.85L4.93,82.85z'/></g></svg>`;
      //   clearInterval(intervalId);
      // }
      // Mic / Text Icon Handling
      if (sendButtonDiv.length !== 0) {
        if (
          this.props.micIconSetting !== null &&
          this.props.micIconSetting !== undefined &&
          this.props.micIconSetting.isMicIcon === true
        ) {
          sendButtonDiv[0].title = "Speak";
          if (document.getElementsByClassName("mic-icon").length === 0) {
            sendButtonDiv[0].innerHTML =
              "<img class='mic-icon' src='" +
              this.props.micIconSetting.micIcon +
              "' alt='Mic Icon'/>";
            clearInterval(intervalId);
          }
        } else {
          sendButtonDiv[0].title = "Typing";
          if (this.props.isSuggestBot) {
            sendButtonDiv[0].innerHTML = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" class="webchat__send-icon"
            width="18px" height="20px" viewBox="0 0 225 225"
            preserveAspectRatio="xMidYMid meet">
           <g transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)" stroke="none">
           <path d="M16 2234 c-9 -8 -16 -17 -16 -19 0 -14 222 -914 229 -931 7 -16 54
           -36 205 -89 108 -37 195 -69 193 -71 -1 -2 -87 -32 -191 -68 -104 -35 -193
           -69 -198 -74 -15 -15 -238 -934 -232 -954 3 -9 13 -20 24 -23 26 -8 2208 1083
           2216 1109 3 10 0 24 -7 31 -17 16 -2182 1105 -2197 1105 -6 0 -18 -7 -26 -16z
           m1863 -1110 c2 -1 -362 -185 -808 -408 -446 -224 -811 -400 -811 -394 1 7 29
           127 63 267 l62 255 385 132 c306 105 385 135 385 149 0 14 -79 44 -385 150
           l-385 132 -62 254 c-34 140 -62 259 -63 264 0 8 1601 -784 1619 -801z"/>
           </g>
           </svg>`;
            clearInterval(intervalId);
          } else {
            sendButtonDiv[0].innerHTML =
              "<svg  viewBox='0 0 32 32' id:'Layer_1' class='webchat__send-icon' xmlns='http://www.w3.org/2000/svg' " +
              "style='enable-background:new 0 0 122.88 116.6;margin-right: 10px;  width: 23px;'" +
              "xml:space='preserve'><g><path d='m27.45 15.11-22-11a1 1 0 0 0 -1.08.12 1 1 0 0 0 -.33 1l2.65 9.77h11.31v2h-11.31l-2.69 9.74a1 1 0 0 0 1 1.26 1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78z'></path> </g>" +
              "</svg>";
            clearInterval(intervalId);
          }
        }
      }
    }, 1000);

    if (this.props.isSuggestBot === true) {
      let webchat_basic = document.getElementsByClassName(
        "webchat__basic-transcript",
      );
      if (webchat_basic.length > 0) {
        if (this.props.mobile !== "true") {
          webchat_basic[0].classList.add("basic-transcript-suggest");
        }
      }
      let scrollbar = document.getElementsByClassName(
        "webchat__basic-transcript__scrollable",
      );
      if (scrollbar.length > 0) {
        scrollbar[0].style.scrollbarWidth = "none";
      }
      let webchat_suggested_action = document.getElementsByClassName(
        "webchat__suggested-actions",
      );
      if (webchat_suggested_action.length > 0) {
        let webchat__basic_transcript__transcript =
          document.getElementsByClassName(
            "webchat__basic-transcript__transcript",
          );
        webchat__basic_transcript__transcript[0].style.paddingBottom =
          3 + "rem";
      }
      const button = document.getElementsByClassName("webchat__icon-button");
      if (
        button !== null &&
        button.length > 0 &&
        this.props.micIconSetting !== null &&
        this.props.micIconSetting !== undefined &&
        this.props.micIconSetting.isMicIcon === false
      ) {
        button[0].classList.add("webchat__icon-button-main");
        button[0].style.backgroundColor = this.props.botSettings.colours.header;
      }
      let sendFooter = document.getElementsByClassName("main");
      if (sendFooter.length > 0) {
        sendFooter[0].classList.add("main-suggest");
        sendFooter[0].parentNode.classList.add("main-footer");
        sendFooter[0].parentNode.style.backgroundColor =
          this.props.botSettings.colours.header;
        sendFooter[0].style.backgroundColor =
          this.props.botSettings.colours.botBackground;
        sendFooter[0].style.borderTopColor =
          this.props.botSettings.colours.botBackground;
        var inputtext = document.getElementsByClassName(
          "webchat__send-box-text-box__input",
        );
        if (inputtext.length > 0) {
          inputtext[0].style.backgroundColor =
            this.props.botSettings.colours.botBackground;
        }
        if (this.props.mobile === "true") {
          sendFooter[0].style.marginLeft = 0 + "%";
          sendFooter[0].parentNode.style.padding = 17 + "px " + 10 + "px";
        }
        var mainFooter = document.getElementsByClassName("main-footer");
        var div = document.createElement("div");
        div.className = "main-suggest-bubble";
        if (
          document.getElementsByClassName("main-suggest-bubble").length === 0
        ) {
          mainFooter[0].appendChild(div);
        }
        // if (this.props.micIconSetting.isMicIcon === true) {
        //   var miciconDiv = document.createElement("div");
        //   miciconDiv.className = "mic-icon";
        //   miciconDiv.innerHTML =
        //     "<img src='" + this.props.micIconSetting.micIcon + "'></img>";
        //   if (document.getElementsByClassName("mic-icon").length === 0) {
        //     button[0].parentElement.classList.add("mic-send-div");
        //     button[0].before(miciconDiv);
        //   }
        // }

        var click = document.createElement("a");
        click.className = "restartchatclick";
        click.id = "restartchatclick";
        click.innerHTML = `<svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width="20px"
            height="20px"
            fill=${
              this.props.botSettings.colours.headerText !== null
                ? this.props.botSettings.colours.headerText
                : "#FFF"
            }
          >
            <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z" />
          </svg>`;
        div.append(click);

        if (this.props.mobile === "true") {
          click.style.marginRight = 15 + "px";
        }
        click.onclick = function (event) {
          event.stopPropagation();
          window.postMessage("restartchat", "*");
        };
        if (
          this.props.micIconSetting !== null &&
          this.props.micIconSetting.isBookNowButton === true &&
          this.props.mobile !== "true"
        ) {
          var clickbooknow = document.createElement("a");
          clickbooknow.className = "clickbooknow";
          clickbooknow.id = "clickbooknow";
          clickbooknow.value = this.props.micIconSetting.bookNowButtonUrl;
          clickbooknow.text = this.props.micIconSetting.bookNowButtonText;
          div.append(clickbooknow);
          clickbooknow.onclick = function (event) {
            event.stopPropagation();
            // console.log(event);
            if (window.parent) {
              window.parent.postMessage(
                "openUrl:" + event.target.value + "",
                "*",
              );
            }
          };
        }
        if (this.props.mobile !== "true") {
          var clickback = document.createElement("a");
          clickback.className = "clickback";
          clickback.id = "clickback";
          clickback.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"
  width="50px" height="50px" fill="#FFF">
 <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
 fill='${
   this.props.botSettings.colours.headerText !== null
     ? this.props.botSettings.colours.headerText
     : "#FFF"
 }'
  stroke="none">
 <path d="M895 1874 c-454 -67 -775 -430 -775 -874 0 -377 240 -711 596 -829 130 -44 259 -58 380 -43 455 58 784 423 784 872 0 404 -266 745 -665 851 -68 19 -258 32 -320 23z m310 -98 c281 -77 501 -305 572 -594 24 -98 21 -284 -5 -384 -65 -242 -233 -436 -462 -535 -209 -89 -464 -82 -668 21 -337 170 -512 564 -412 926 82 294 313 512 610 575 83 18 283 13 365 -9z"/>
 <path d="M787 1100 c-130 -101 -207 -167 -207 -178 0 -22 19 -42 40 -42 8 0 96 63 194 140 99 77 182 140 186 140 4 0 87 -63 186 -140 98 -77 186 -140 195 -140 20 0 39 20 39 42 0 10 -75 76 -200 173 -109 85 -205 158 -213 161 -8 3 -101 -63 -220 -156z"/>
 </g>
 </svg>`;
          div.append(clickback);
          clickback.onclick = function (event) {
            event.stopPropagation();
            if (window.parent) {
              window.parent.postMessage("closemessenger", "*");
            }
          };
        }
      }
    }

    const getdiv = document.getElementsByClassName(
      "webchat__send-text-box-count",
    );
    if (
      this.props.inTwiliochat === false &&
      this.props.inZenDesk === false &&
      this.props.inAwsConnect === false &&
      this.props.botSettings.features.fixedResponses === true
    ) {
      if (getdiv === null || getdiv.length === 0) {
        const form = document.querySelector("form");
        const main = document.getElementsByClassName("main");
        if (form !== null) {
          const button = document.getElementsByClassName(
            "webchat__icon-button",
          );
          let disableButton = document.createElement("button");
          main[0].appendChild(disableButton);
          disableButton.type = "button";
          disableButton.style.display = "none";
          disableButton.style.backgroundColor = "Transparent";
          disableButton.style.border = "0";
          disableButton.style.outline = "0";
          disableButton.style.padding = "0";
          disableButton.style.width = "40px";
          disableButton.disabled = "disabled";
          disableButton.style.opacity = "0.4";
          disableButton.innerHTML =
            // "<svg version='1.1' id='Layer_1' class='webchat__send-icon' xmlns='http://www.w3.org/2000/svg' " +
            // "xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 122.88 116.6' " +
            // "style='enable-background:new 0 0 122.88 116.6;margin-right: 10px;  width: 25px;'" +
            // "xml:space='preserve'><g><path d='M24.44,0h74.01c6.68,0,12.77,2.75,17.19,7.17c4.47,4.47,7.24,10.65,7.24,17.45v67.35c0,6.8-2.78,12.98-7.25,17.45 c-4.42,4.42-10.51,7.17-17.19,7.17H24.44c-6.68,0-12.77-2.75-17.19-7.17C2.77,104.96,0,98.78,0,91.98V24.62 c0-6.81,2.77-12.99,7.24-17.45C11.67,2.75,17.75,0,24.44,0L24.44,0z M64.51,39.22v28.33c0,0.85-0.34,1.62-0.9,2.17 c-0.56,0.56-1.33,0.9-2.17,0.9c-0.85,0-1.62-0.34-2.17-0.9c-0.56-0.56-0.9-1.32-0.9-2.17V39.22l-10.92,9.53 c-0.63,0.55-1.43,0.8-2.21,0.76c-0.79-0.05-1.55-0.39-2.12-1.02c-0.56-0.63-0.81-1.43-0.77-2.21c0.05-0.78,0.39-1.54,1.02-2.1 l16.04-14c0.59-0.52,1.33-0.77,2.06-0.77c0.73,0.01,1.46,0.28,2.02,0.8l16.03,14c0.61,0.56,0.95,1.31,1,2.08 c0.05,0.78-0.21,1.57-0.77,2.2l-0.02,0.02c-0.56,0.62-1.32,0.95-2.09,1h-0.01c-0.78,0.04-1.58-0.21-2.21-0.77L64.51,39.22 L64.51,39.22z M4.93,82.85c0.85,3.45,2.55,6.55,4.83,9.01c3.36,3.62,7.99,5.87,13.1,5.87h77.17c0.21,0,0.41,0,0.62-0.01l1.25-0.09 c4.36-0.47,8.29-2.6,11.23-5.77c2.28-2.46,3.97-5.55,4.83-9V24.62c0-5.28-2.17-10.09-5.67-13.58c-3.54-3.54-8.44-5.74-13.84-5.74 H24.44c-5.4,0-10.3,2.2-13.84,5.74c-3.49,3.49-5.66,8.3-5.66,13.58V82.85L4.93,82.85z'/></g></svg>`;
            "<svg  viewBox='0 0 32 32' id:'Layer_1' class='webchat__send-icon' xmlns='http://www.w3.org/2000/svg' " +
            "style='enable-background:new 0 0 122.88 116.6;margin-right: 10px;  width: 23px;'" +
            "xml:space='preserve'><g><path d='m27.45 15.11-22-11a1 1 0 0 0 -1.08.12 1 1 0 0 0 -.33 1l2.65 9.77h11.31v2h-11.31l-2.69 9.74a1 1 0 0 0 1 1.26 1 1 0 0 0 .45-.11l22-11a1 1 0 0 0 0-1.78z'></path> </g>" +
            "</svg>";
          const msgBox = document.getElementsByClassName(
            "webchat__send-box-text-box__input",
          );
          // const input = msgBox[0];
          form.setAttribute("id", "form_send");

          let div_sendBoxTextCount = document.createElement("div");
          document
            .getElementById("form_send")
            .appendChild(div_sendBoxTextCount);
          div_sendBoxTextCount.classList.add("webchat__send-text-box-count");
          div_sendBoxTextCount.setAttribute(
            "id",
            "webchat__send-text-box-count",
          );
          const span = document.createElement("span");
          div_sendBoxTextCount.appendChild(span);
          span.setAttribute("id", "span-count");
          span.style.marginLeft = "5px";
          span.style.fontSize = "14px";

          function _set() {
            // var len = this.value.replace(/ /g, "").length || 0;
            // let totalLen = 70;
            // if (len <= 40) {
            //   span.style.color = "green";
            //   button[0].style.display = "block";
            //   disableButton.style.display = "none";
            //   len = this.value !== "" ? 40 - len : "";
            // } else {
            //   button[0].style.display = "none";
            //   disableButton.style.display = "block";
            //   span.style.color = "red";
            //   len = "-" + (30 - (totalLen - len));
            // }
            // span.innerHTML = len;
          }
          //  console.log('msgBox', msgBox);
          if (msgBox.length > 0) {
            const input = msgBox[0];
            input.addEventListener("keyup", (e) => {
              if (
                this.props.inTwiliochat === false &&
                this.props.inZenDesk === false &&
                this.props.inAwsConnect === false
              ) {
                document.getElementById(
                  "webchat__send-text-box-count",
                ).style.display = "block";
                let len = input.value.replace(/ /g, "").length;
                // if (len <= 70) {
                //   _set.call(input);
                // }
              }
            });
            // input.addEventListener("keypress", (e) => {
            //   if (
            //     this.props.inTwiliochat === false &&
            //     this.props.inZenDesk === false
            //   ) {
            //     let len = input.value.replace(/ /g, "").length;
            //     if (len >= 70) {
            //       e.stopPropagation();
            //       e.preventDefault();
            //     } else if (len > 40) {
            //       if (e.key === "Enter") {
            //         input.focus();
            //         e.stopPropagation();
            //         e.preventDefault();
            //       }
            //     }
            //   }
            // });
          } else {
            console.warn("msgBox element not found");
          }
        }
      }
    } else {
      if (document.getElementById("webchat__send-text-box-count") !== null) {
        document.getElementById("webchat__send-text-box-count").style.display =
          "none";
      }
    }
    if (
      this.props.botSettings.features.addOnUpsells &&
      this.state.isServiceAvailable
    ) {
      const divcurated = document.getElementsByClassName(
        "webchat__send-curated-option",
      );
      if (divcurated === null || divcurated.length === 0) {
        const getMainDiv = document.getElementsByClassName("main");
        const formdiv = document.getElementById("form_send");
        if (getMainDiv !== null && getMainDiv.length > 0 && formdiv !== null) {
          let createCuratedDiv = document.createElement("div");
          formdiv.parentNode.insertBefore(createCuratedDiv, formdiv);
          createCuratedDiv.className = "webchat__send-curated-option";
          createCuratedDiv.innerHTML =
            "<svg version='1.0' xmlns='http://www.w3.org/2000/svg' " +
            "width='20px' height='20px' viewBox='0 0 512.000000 512.000000' preserveAspectRatio='xMidYMid meet'>" +
            "<g transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)' fill='#000000' stroke='none'>" +
            "<path d='M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594 -662 -63 -99 -186 -351 -230 -471 -49 -134 -102 -340 -128 -499 -31 -195 -31 -565 0 -760 45 -276 116 -498 237 -745 132 -269 269 -460 489 -681 221 -220 412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 276 45 498 116 745 237 269 132 460 269 681 489 220 221 357 412 489 681 88 179 132 296 180 476 63 240 78 371 78 649 0 278 -15 409 -78 649 -48 180 -92 297 -180 476 -132 269 -269 460 -489 681 -221 220 -412 357 -681 489 -246 121 -474 193 -740 235 -147 23 -475 34 -615 20z m468 -401 c488 -53 934 -270 1288 -623 415 -415 634 -943 634 -1526 0 -583 -219 -1111 -634 -1526 -415 -415 -943 -634 -1526 -634 -583 0 -1111 219 -1526 634 -415 415 -634 943 -634 1526 0 583 219 1111 634 1526 349 349 800 569 1276 623 110 12 376 13 488 0z'/>" +
            "<path d='M2515 3761 c-67 -17 -127 -74 -144 -138 -7 -24 -11 -190 -11 -440 l0 -403 -390 0 c-251 0 -408 -4 -442 -11 -65 -14 -129 -73 -148 -136 -27 -89 18 -191 102 -232 43 -20 56 -21 461 -21 l416 0 3 -422 c3 -407 4 -425 24 -463 11 -22 40 -53 63 -70 37 -26 51 -30 111 -30 60 0 74 4 111 30 23 17 52 48 63 70 20 38 21 56 24 463 l3 422 416 0 c405 0 418 1 461 21 84 41 129 143 102 232 -19 63 -83 122 -148 136 -34 7 -191 11 -442 11 l-390 0 0 403 c0 250 -4 416 -11 440 -11 43 -59 101 -98 121 -35 18 -99 26 -136 17z' />" +
            "</g> </svg>";
          createCuratedDiv.addEventListener("click", (e) => {
            this.setState({ open_service_popup: true });
          });
        }
      }
    }
    if (
      this.props.customStyle === "custom" &&
      this.props.botSettings.isHeaderHide === true
    ) {
      const restartbtnDiv =
        document.getElementsByClassName("restart-buttondiv");
      if (restartbtnDiv === null || restartbtnDiv.length === 0) {
        const getMainDiv = document.getElementsByClassName("main");
        const formdiv = document.getElementsByClassName(
          "webchat__send-box-text-box",
        );
        if (getMainDiv !== null && getMainDiv.length > 0 && formdiv !== null) {
          let createRestartDiv = document.createElement("div");
          formdiv[0].parentNode.insertBefore(createRestartDiv, formdiv[0]);
          createRestartDiv.className = "restart-buttondiv";
          createRestartDiv.innerHTML =
            "<svg version='1.0' xmlns='http://www.w3.org/2000/svg' " +
            "width='20px' height='20px' viewBox='0 0 512.000000 512.000000' preserveAspectRatio='xMidYMid meet'>" +
            "<g transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)' fill='currentColor' stroke='none'>" +
            "<path d='M2470 4617 c-19 -12 -43 -38 -54 -57 -21 -35 -21 -46 -24 -1063 -2 -737 1 -1040 9 -1070 16 -59 75 -114 134 -122 57 -9 129 24 162 74 l23 34 0 1061 c0 1041 0 1062 -20 1094 -30 49 -75 72 -141 72 -42 0 -65 -6 -89 -23z' />" +
            "<path d='M1165 4146 c-91 -40 -123 -164 -64 -247 34 -48 87 -65 264 -84 88 -10 163 -21 168 -24 4 -4 -23 -29 -60 -57 -96 -70 -214 -183 -229 -221 -32 -74 -2 -168 66 -207 39 -23 122 -26 158 -7 13 7 52 39 88 71 75 68 185 152 191 147 2 -3 -6 -84 -18 -181 l-21 -176 23 -47 c13 -26 36 -56 50 -66 29 -21 103 -33 143 -23 32 8 83 51 101 85 18 35 109 792 100 837 -7 39 -46 89 -85 109 -26 14 -740 105 -813 105 -17 -1 -46 -7 -62 -14z' />" +
            "<path d='M3130 3959 c-62 -26 -100 -85 -100 -154 0 -85 32 -122 159 -181 298 -139 574 -413 710 -705 49 -105 94 -237 118 -349 26 -123 26 -448 -1 -575 -125 -594 -585 -1051 -1176 -1165 -527 -103 -1080 99 -1423 518 -66 81 -101 102 -170 102 -52 0 -100 -29 -135 -80 -20 -29 -23 -44 -20 -92 5 -65 18 -87 123 -204 253 -282 605 -483 990 -564 129 -28 438 -38 582 -20 660 82 1235 534 1468 1155 131 351 149 749 51 1119 -132 498 -489 924 -964 1154 -97 47 -166 61 -212 41z' />" +
            "<path d='M975 3115 c-165 -60 -138 -307 37 -331 62 -9 110 9 152 56 120 133 -20 337 -189 275z' />" +
            "<path d='M844 2531 c-153 -70 -124 -294 42 -326 80 -15 170 42 194 122 24 80 -13 162 -90 201 -54 27 -92 28 -146 3z' />" +
            "<path d='M903 1905 c-47 -29 -83 -92 -83 -146 1 -49 32 -112 70 -139 40 -28 126 -38 170 -20 73 30 123 128 101 200 -34 114 -158 165 -258 105z' />" +
            "</g> </svg>";
          createRestartDiv.onclick = function (event) {
            event.stopPropagation();
            window.postMessage("restartchat", "*");
          };
        }
      }
    }
  }

  // cookies
  getName = (assistantDetail, type) => {
    if (assistantDetail !== null && assistantDetail.length > 0) {
      const findIndex = assistantDetail.findIndex(
        (i) =>
          i.locale ===
          (this.state.language === "zh-TW" ? "hk" : this.state.language),
      );
      if (findIndex === -1) {
        const getEn = assistantDetail.filter((c) => c.locale === "en");
        if (getEn !== null && getEn.length > 0) {
          if (type === "cookiesText") {
            return getEn[0].statement; // Return raw HTML string
          }
        }
      } else {
        if (type === "cookiesText") {
          return assistantDetail[findIndex].statement; // Return raw HTML string
        }
      }
    }
    return "";
  };

  handleLinkClick = (e) => {
    e.preventDefault();
    const href = e.target.closest("a")?.getAttribute("href");

    if (href) {
      if (href.includes("myma.ai")) {
        this.setState({
          isOpenModal: true,
          modalContent: href,
        });
      } else {
        // If the link is external, open it in a new tab
        window.open(href, "_blank");
      }
    }
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  //
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  handleVisitorEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };
  handleVisitorNameChange = (e) => {
    this.setState({ name: e.target.value });
  };
  handleVisitorPhoneNumerChange = (e) => {
    let val = true;
    let str = e.target.value.split("");
    for (let i = 0; i < str.length; i++) {
      let code = str[i];
      code = code.charCodeAt(0);
      if (
        (code >= 48 || code === 45 || code === 40 || code === 41) &&
        (code <= 57 || code === 45 || code === 40 || code === 41)
      )
        val = true;
      else val = false;
    }
    if (val) this.setState({ phoneNumber: e.target.value });
  };
  handleVisitorCheckBoxChange = (e) => {
    this.setState({ consentGiven: e.target.checked });
  };
  hadleVisitorFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value });
  };
  hadleVisitorLastNameChange = (e) => {
    this.setState({ lastName: e.target.value });
  };
  hadleVisitorZipCodeChange = (e) => {
    this.setState({ zipCode: e.target.value });
  };

  handleChangeLanguage = (id, sendtobot) => {
    if (window.parent) {
      window.parent.postMessage("langDetect:" + id + "", "*");
    }
    const findLanguage = localeOptions.find((elem) => {
      return elem.id === id;
    });
    console.log(
      "handleChangeLanguage",
      id,
      sendtobot,
      localeOptions,
      findLanguage,
    );

    if (findLanguage) {
      this.setState({
        language: findLanguage.id,
        languageCode: findLanguage.code,
        langLocale: findLanguage.locale,
      });
      localStorage.setItem(this.props.language_state_store, findLanguage.id);
    }

    if (sendtobot) {
      this.props.bookingApp.callbacks.getStore().dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/lang-update",
          value: {
            lang: id,
          },
        },
      });
    }

    if (
      this.props.persistentMenu.filter((i) => i.locale.includes(id)).length > 0
    ) {
      let menu = this.props.persistentMenu.filter((i) => i.locale.includes(id));
      this.setState({
        persistentMenuData: menu,
      });
    } else {
      let menu = this.props.persistentMenu.filter((i) =>
        i.locale.includes("default"),
      );
      let menuItem = [];
      menu[0].callToActions.map((item) => {
        var input = item.title;
        if (input !== "") {
          if (id === "en") {
            menuItem.push({
              title: item.title,
              type: item.type,
              payLoad: item.payLoad,
              url: item.url,
            });
          } else {
            if (
              item.payLoad !== "select_property" &&
              item.payLoad !== "switch_language" &&
              item.payLoad !== "restart" &&
              item.payLoad !== "hidebot"
            ) {
              const req = fetch(TRANSLATE_URL, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  q: input,
                  target: id,
                }),
              });
              req.then((m) => {
                m.json().then((k) => {
                  menuItem.push({
                    title: k.output,
                    type: item.type,
                    payLoad: item.payLoad,
                    url: item.url,
                  });
                });
              });
            } else {
              menuItem.push({
                title: item.title,
                type: item.type,
                payLoad: item.payLoad,
                url: item.url,
              });
            }
          }
          this.setState({
            persistentMenuData: [
              {
                locale: id,
                callToActions: menuItem,
              },
            ],
          });
        }
      });
    }
    this.close_language_popup();
  };

  handleMenuClick = (data) => {
    if (data.itemType === "postback") {
      if (data.items.payLoad === "switch_language") {
        this.setState({ open_language_popup: true });
      } else if (data.items.payLoad === "select_property") {
        this.setState({ open_property_popup: true });
      } else if (data.items.payLoad === "restart") {
        this.end_clicked();
      } else if (data.items.payLoad === "hidebot") {
        this.hide_bot_confirm();
      } else {
        this.props.bookingApp.callbacks.getStore().dispatch({
          type: "WEB_CHAT/SEND_MESSAGE",
          payload: {
            text: data.items.payLoad,
          },
        });
      }
    } else {
      if (data.items.url.includes("utm_source") === false) {
        if (
          data.items.url !== "" &&
          this.state.googleAnalytics !== undefined &&
          this.state.googleAnalytics !== null &&
          this.state.googleAnalytics.utmSource !== undefined
        ) {
          var options = data.items.url.lastIndexOf("&");
          if (data.items.url.indexOf("?") == "-1") {
            data.items.url =
              data.items.url +
              `?utm_source=${
                this.state.googleAnalytics.utmSource !== undefined
                  ? this.state.googleAnalytics.utmSource
                  : ""
              }&utm_medium=${
                this.state.googleAnalytics.utmMedium !== undefined
                  ? this.state.googleAnalytics.utmMedium
                  : ""
              }`;
          } else if (data.items.url.indexOf("&") == "-1") {
            data.items.url =
              data.items.url +
              `&utm_source=${
                this.state.googleAnalytics.utmSource !== undefined
                  ? this.state.googleAnalytics.utmSource
                  : ""
              }&utm_medium=${
                this.state.googleAnalytics.utmMedium !== undefined
                  ? this.state.googleAnalytics.utmMedium
                  : ""
              }`;
          } else {
            data.items.url =
              data.items.url.substr(0, data.items.url.lastIndexOf("&")) +
              `&utm_source=${
                this.state.googleAnalytics.utmSource !== undefined
                  ? this.state.googleAnalytics.utmSource
                  : ""
              }&utm_medium=${
                this.state.googleAnalytics.utmMedium !== undefined
                  ? this.state.googleAnalytics.utmMedium
                  : ""
              }` +
              data.items.url.substr(data.items.url.lastIndexOf("&"));
          }
        }
      }
      this.addLinks(data.items.url);
      if (window.parent) {
        window.parent.postMessage("openUrl:" + data.items.url + "", "*");
      } else {
        window.location = data.items.url;
      }
    }
  };
  handleCancelFeedbackResponse = () => {
    this.setState({ leaveFeedbackMessage: "" });
    let feedback_popup = document.getElementById("feedback_popup");
    feedback_popup.style.display = "none";
  };
  getMessageTranslate = (value) => {
    switch (this.state.language) {
      case "af":
        return (
          "Dankie dat jy vir ons jou navraag gestuur het! Ons vra om verskoning dat dit nie dadelik beantwoord is nie, ons span werk tans daaraan en sal so gou moontlik na jou terugkom! Jou kaartjienommer is " +
          value +
          ""
        );
      case "ar":
        return (
          "" +
          value +
          " شكرا لك على إرسال استفسارك إلينا! نعتذر عن عدم الرد على الفور، ويعمل فريقنا حاليًا على حل المشكلة وسيقوم بالرد عليك في أقرب وقت ممكن! رقم التذكرة الخاص بك هو"
        );
      case "de":
        return (
          "Vielen Dank für Ihre Anfrage! Wir entschuldigen uns dafür, dass Ihre Anfrage nicht sofort beantwortet wurde. Unser Team arbeitet derzeit daran und wird sich so schnell wie möglich bei Ihnen melden! Ihre Ticketnummer lautet " +
          value +
          ""
        );
      case "es":
        return (
          "¡Gracias por enviarnos tu consulta! Lamentamos que no haya sido respondida de inmediato, nuestro equipo está trabajando actualmente en ello y se comunicará con usted lo antes posible. Su número de billete es " +
          value +
          ""
        );
      case "fi":
        return (
          "Kiitos, että lähetit meille kyselysi! Pahoittelemme, ettei siihen heti vastattu. Tiimimme työskentelee parhaillaan asian parissa ja ottaa sinuun yhteyttä mahdollisimman pian! Lippusi numero on " +
          value +
          ""
        );
      case "fr":
        return (
          "Merci de nous avoir envoyé votre demande ! Nous sommes désolés de ne pas avoir reçu de réponse immédiate, notre équipe y travaille actuellement et vous répondra dans les plus brefs délais ! Votre numéro de billet est " +
          value +
          ""
        );
      case "hi":
        return (
          "हमें अपनी जांच भेजने के लिए धन्यवाद! हम क्षमा चाहते हैं कि इसका उत्तर सीधे नहीं दिया गया, हमारी टीम वर्तमान में इस पर काम कर रही है और जल्द से जल्द आपसे संपर्क करेगी! आपका टिकट नंबर है " +
          value +
          ""
        );
      case "id":
        return (
          "Terima kasih telah mengirimkan pertanyaan Anda kepada kami! Kami mohon maaf karena tidak langsung dijawab, tim kami sedang mengerjakannya dan akan menghubungi Anda sesegera mungkin! Nomor tiket Anda adalah " +
          value +
          ""
        );
      case "ja":
        return (
          "お問い合わせをお送りいただきありがとうございます。すぐに回答できなかったことをお詫び申し上げます。現在、チームが対応中ですので、できるだけ早くご連絡いたします。あなたのチケット番号は " +
          value +
          ""
        );
      case "ko":
        return (
          "문의사항을 보내주셔서 감사합니다! 즉시 답변을 드리지 못한 점 사과드립니다. 현재 팀에서 작업 중이므로 최대한 빨리 답변해 드리겠습니다. 귀하의 티켓 번호는 다음과 같습니다 " +
          value +
          ""
        );
      case "mi":
        return (
          "Mauruuru koe mo te tuku mai i to patai! E mihi ana matou na te mea kaore i whakautua tonutia, kei te mahi tonu ta matou roopu i tenei wa ka hoki wawe mai ki a koe! Ko to nama tikiti " +
          value +
          ""
        );
      case "ru":
        return (
          "Спасибо, что отправили нам свой запрос! Приносим извинения, что не ответили сразу, наша команда сейчас работает над этим и свяжется с вами как можно скорее! Номер вашего билета " +
          value +
          ""
        );
      case "tl":
        return (
          "Salamat sa pagpapadala sa amin ng iyong katanungan! Humihingi kami ng paumanhin na hindi ito agad nasagot, kasalukuyang ginagawa ito ng aming team at babalikan ka sa lalong madaling panahon! Ang iyong numero ng tiket ay " +
          value +
          ""
        );
      case "th":
        return (
          "ขอบคุณสำหรับการส่งคำถามของคุณถึงเรา! เราต้องขออภัยที่ไม่ได้ตอบกลับทันที ทีมงานของเรากำลังดำเนินการอยู่และจะติดต่อกลับโดยเร็วที่สุด! หมายเลขตั๋วของคุณคือ " +
          value +
          ""
        );
      case "vi":
        return (
          "Cảm ơn bạn đã gửi cho chúng tôi yêu cầu của bạn! Chúng tôi xin lỗi vì nó không được trả lời ngay lập tức, nhóm của chúng tôi hiện đang giải quyết vấn đề này và sẽ liên hệ lại với bạn sớm nhất có thể! Số vé của bạn là " +
          value +
          ""
        );
      case "zh":
        return (
          "感谢您向我们发送您的询问！对于未能立即回复您的问题，我们深表歉意，我们的团队目前正在处理该问题，并将尽快回复您！您的票号是 " +
          value +
          ""
        );
      case "zh-TW":
        return (
          "感謝您向我們發送您的詢問！對於未能立即回覆您的問題，我們深表歉意，我們的團隊目前正在處理該問題，並將盡快回覆您！您的票號是 " +
          value +
          ""
        );
      default:
        return (
          "Thank you for sending us your enquiry! We do apologise that it was not answered straightaway, our team is currently working on it and will get back to you as soon as possible! Your ticket number is " +
          value +
          ""
        );
    }
  };
  handleFeedBackResponse = async (body, name, phone, email) => {
    let button = document.getElementById("feedback_button");
    if (button !== null && button.value !== undefined) {
      document.getElementById("feedback_popup_body").classList.remove("area");
      document.getElementById("feedback_popup_body").classList.add("closepop");
      let feedback_popup = document.getElementById("feedback_popup");
      feedback_popup.style.display = "none";
      var leaveFeedback = {
        groupId: this.props.gid,
        messageId: button.value,
        leaveMessage: this.state.leaveFeedbackMessage,
      };
      try {
        fetch(`${LEAVE_FEEDBACK}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(leaveFeedback),
        });
      } catch (error) {}
      var tags = ["Feedback"];
      const data = new FormData();
      data.append("formId", null);
      data.append("groupId", this.props.gid);
      data.append("propertyId", this.props.pid === "-1" ? "" : this.props.pid);
      data.append("conversationId", this.props.directline.conversationId);
      data.append("source", "WebSite");
      data.append("tags", tags);
      data.append("notes", body);
      data.append("bcc", "andy@bookmebob.com");
      data.append("requesterName", name);
      data.append("requesterEmail", email);
      data.append("requesterPhoneNumber", phone);
      data.append("creator", "Bot");
      data.append("isDefault", true);
      const ip = await publicIp.v4();
      data.append("ipAddress", ip);
      fetch(process.env.REACT_APP_BFF_API + "/public/form-tickets", {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        cache: "no-cache",
        body: data,
      }).then((response) => {
        response.json().then((res) => {
          var msg = `${this.getMessageTranslate(res.result.id)}`;

          fetch(process.env.REACT_APP_API_URL + "/sendmessageactivityByBot", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              conversationId: this.props.directline.conversationId,
              message: "" + msg + "",
              from: Math.random(),
              summary: "Fallback",
            }),
          }).catch((err) => {
            console.error("Bmb ticket creation failed :(.");
            console.error(err);
          });
          var msgpayload = {
            gid: this.props.gid,
            iid: this.props.iid,
            pid: this.props.pid,
            vid: this.props.vid,
            sid: this.props.sid,
            cid: this.props.directline.conversationId,
            time: new Date().toISOString(),
            source: "Bot",
            message: msg,
            tag: "",
            agentId: "",
          };
          fetch(process.env.REACT_APP_API_URL + "/saveMessage", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(msgpayload),
          }).catch((err) => {
            console.error("Bmb livechat logging failed :(.");
            console.error(err);
          });
        });
      });
      this.setState({ leaveFeedbackMessage: "" });
    }
  };
  savePrechat = async () => {
    console.log("savePrechat", this.props.prechatdata);
    const addInfo = this.props.prechatdata;
    var user = {
      iid: this.props.iid,
      gid: this.props.gid,
      pid: this.props.pid,
      name: addInfo.userName,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      zipCode: this.state.zipCode,
      email: addInfo.userEmail,
      phoneNumber: this.state.phoneNumber,
      consentGiven: this.state.consentGiven,
      additionalInfo: {
        UserName: addInfo.userName,
        UserEmail: addInfo.userEmail,
        PropertyName: addInfo.propertyName,
        ChainName: addInfo.chainName,
        UserType: addInfo.userType,
        GroupName: addInfo.groupName,
        BusinessName: addInfo.businessName,
        AccountId: addInfo.accountId,
        ContactId: addInfo.contactId,
      },
    };
    const req = await fetch(`${VISITOR_URL}/${this.props.vid}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: user,
      }),
    });

    localStorage.setItem(this.props.prechat_store, JSON.stringify(addInfo));
  };
  componentDidMount() {
    //powered by logo code
    if (
      this.props.prechatdata !== null &&
      this.props.vid &&
      localStorage.getItem(this.props.prechat_store) !==
        JSON.stringify(this.props.prechatdata)
    ) {
      this.savePrechat();
    }
    const filtered = this.state.languageOptions.filter((el) => {
      return this.props.botSettings.languages.indexOf(el.id) !== -1;
    });
    var langCode = this.state.language;
    const selectedLang = this.state.languageOptions.filter(
      (el) => el.id === this.state.language,
    );
    if (selectedLang.length > 0) {
      this.setState({
        languageOptions: filtered,
        languageCode: selectedLang[0].code,
        langLocale: selectedLang[0].locale,
      });
    } else {
      this.setState({ languageOptions: filtered });
    }
    if (
      this.props.persistentMenu !== undefined ||
      this.props.persistentMenu !== null
    ) {
      if (this.state.persistentMenuData.length === 0) {
        if (
          this.props.persistentMenu.filter((i) => i.locale.includes(langCode))
            .length > 0
        ) {
          let menu = this.props.persistentMenu.filter((i) =>
            i.locale.includes(langCode),
          );
          this.setState({
            persistentMenuData: menu,
          });
        } else {
          let menu = this.props.persistentMenu.filter((i) =>
            i.locale.includes("default"),
          );
          let menuItem = [];
          menu[0].callToActions.map((item) => {
            var input = item.title;
            if (input !== "") {
              if (langCode === "en") {
                menuItem.push({
                  title: item.title,
                  type: item.type,
                  payLoad: item.payLoad,
                  url: item.url,
                });
              } else {
                if (
                  item.payLoad !== "select_property" &&
                  item.payLoad !== "switch_language" &&
                  item.payLoad !== "restart" &&
                  item.payLoad !== "hidebot"
                ) {
                  const req = fetch(TRANSLATE_URL, {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      q: input,
                      target: langCode,
                    }),
                  });
                  req.then((m) => {
                    m.json().then((k) => {
                      menuItem.push({
                        title: k.output,
                        type: item.type,
                        payLoad: item.payLoad,
                        url: item.url,
                      });
                    });
                  });
                } else {
                  menuItem.push({
                    title: item.title,
                    type: item.type,
                    payLoad: item.payLoad,
                    url: item.url,
                  });
                }
              }
              this.setState({
                persistentMenuData: [
                  {
                    locale: langCode,
                    callToActions: menuItem,
                  },
                ],
              });
            }
          });
        }
      }
    }

    if (
      this.props.botSettings !== undefined ||
      this.props.botSettings !== null
    ) {
      if (
        this.props.botSettings.bubbleSettings !== undefined &&
        this.props.botSettings.bubbleSettings !== null
      ) {
        if (
          this.props.botSettings.bubbleSettings.bubbleType !== undefined &&
          this.props.botSettings.bubbleSettings.bubbleType !== null
        ) {
          this.setState({
            bubble_type: this.props.botSettings.bubbleSettings.bubbleType,
          });
        } else {
          this.setState({ bubble_type: "Bubble" });
        }
      }
      var visitorSetting = this.props.botSettings.visitorSettings;
      if (langCode !== "en") {
        if (
          this.props.botSettings.languageVisitorSetting !== null &&
          this.props.botSettings.languageVisitorSetting !== undefined
        ) {
          var langVisitor =
            this.props.botSettings.languageVisitorSetting.filter(
              (x) => x.languageCode === langCode,
            );
          if (langVisitor.length > 0) {
            visitorSetting = langVisitor[0];
          }
        }
      }

      var inactivesession = this.props.botSettings.inactivePopUpSession;
      if (langCode !== "en") {
        if (
          this.props.botSettings.languageInactivePopUpSession !== null &&
          this.props.botSettings.languageInactivePopUpSession !== undefined
        ) {
          var langsession =
            this.props.botSettings.languageInactivePopUpSession.filter(
              (x) => x.languageCode === langCode,
            );
          if (langsession.length > 0) {
            inactivesession = langsession[0];
          }
        }
      }

      var inactivewarning = this.props.botSettings.inactivePopUpWarning;
      if (langCode !== "en") {
        if (
          this.props.botSettings.languageInactivePopUpWarning !== null &&
          this.props.botSettings.languageInactivePopUpWarning !== undefined
        ) {
          var langsession =
            this.props.botSettings.languageInactivePopUpWarning.filter(
              (x) => x.languageCode === langCode,
            );
          if (langsession.length > 0) {
            inactivewarning = langsession[0];
          }
        }
      }
      this.setState({
        visitorSettings: visitorSetting,
        inactivePopupSession: inactivesession,
        inactivePopUpWarning: inactivewarning,
      });
    }
    const self = this;
    var ignoreClickOnMeElement = document.getElementById("chat_box");
    if (
      ignoreClickOnMeElement !== null &&
      ignoreClickOnMeElement !== undefined
    ) {
      document.addEventListener("click", function (event) {
        if (self.state.ask_bot_hide === true) {
          var isClickInsideElement = ignoreClickOnMeElement.contains(
            event.target,
          );
          if (isClickInsideElement) {
            self.setState({ ask_bot_hide: false });
          }
        }
      });
    }

    var ignoreClickOnMeElementVisitor =
      document.getElementById("chat_box_visitor");
    if (
      ignoreClickOnMeElementVisitor !== null &&
      ignoreClickOnMeElementVisitor !== undefined
    ) {
      document.addEventListener("click", function (event) {
        if (self.state.ask_bot_hide === true) {
          var isClickInsideElement = ignoreClickOnMeElementVisitor.contains(
            event.target,
          );
          if (isClickInsideElement) {
            self.setState({ ask_bot_hide: false });
          }
        }
      });
    }
    if (this.props.pid !== undefined && this.props.pid !== null) {
      this.GetServiceAvailable(this.props.property_state_store);
    }
    if (this.props.pid !== undefined && this.props.pid !== null) {
      const req = fetch(ANALYTICS_URL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          propertyId: this.props.pid,
          groupId: this.props.gid,
        }),
      });
      req.then((m) => {
        m.json().then((k) => {
          if (
            k.googleAnalyticsIntegration !== undefined &&
            k.googleAnalyticsIntegration !== null
          ) {
            this.setState({ googleAnalytics: k.googleAnalyticsIntegration });
          }
        });
      });
    }
    if (this.props.gid != undefined && this.props.gid !== null) {
      this.loadFormSetting(this.props.gid, this.props.pid);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.prechatdata !== this.props.prechatdata &&
      localStorage.getItem(this.props.prechat_store) !==
        JSON.stringify(this.props.prechatdata) &&
      this.props.vid &&
      this.props.prechatdata !== null
    ) {
      this.savePrechat();
    }
    if (
      prevProps.isRestartcon !== this.props.isRestartcon &&
      this.props.isRestartcon !== undefined
    ) {
      this.setState({ ask_close: this.props.isRestartcon });
      this.setState({ menu_open: false });
      if (this.props.messenger === true) {
        this.props.bot_restartClick();
      }
    }
    if (
      prevProps.availblity !== this.props.availblity &&
      this.props.availblity !== undefined
    ) {
      this.availblityForm(this.props.availblity);
    }

    if (prevProps.openZChat_popup !== this.props.openZChat_popup) {
      this.setState({ open_ZChatfeedback_popup: this.props.openZChat_popup });
    }

    if (prevProps.property_popup !== this.props.property_popup) {
      this.setState({ open_property_popup: this.props.property_popup });
    }
    if (prevProps.lang !== this.props.lang && this.props.lang !== undefined) {
      this.handleChangeLanguage(
        this.props.lang,
        this.props.autoDetect === true ? false : true,
      );
      if (
        this.props.botSettings !== undefined ||
        this.props.botSettings !== null
      ) {
        var visitorSetting = this.props.botSettings.visitorSettings;
        if (this.props.lang !== "en") {
          if (
            this.props.botSettings.languageVisitorSetting !== null &&
            this.props.botSettings.languageVisitorSetting !== undefined
          ) {
            var langVisitor =
              this.props.botSettings.languageVisitorSetting.filter(
                (x) => x.languageCode === this.props.lang,
              );
            if (langVisitor.length > 0) {
              visitorSetting = langVisitor[0];
            }
          }
        }

        var inactivesession = this.props.botSettings.inactivePopUpSession;
        if (this.props.lang !== "en") {
          if (
            this.props.botSettings.languageInactivePopUpSession !== null &&
            this.props.botSettings.languageInactivePopUpSession !== undefined
          ) {
            var langsession =
              this.props.botSettings.languageInactivePopUpSession.filter(
                (x) => x.languageCode === this.props.lang,
              );
            if (langsession.length > 0) {
              inactivesession = langsession[0];
            }
          }
        }

        var inactivewarning = this.props.botSettings.inactivePopUpWarning;
        if (this.props.lang !== "en") {
          if (
            this.props.botSettings.languageInactivePopUpWarning !== null &&
            this.props.botSettings.languageInactivePopUpWarning !== undefined
          ) {
            var langsession =
              this.props.botSettings.languageInactivePopUpWarning.filter(
                (x) => x.languageCode === this.props.lang,
              );
            if (langsession.length > 0) {
              inactivewarning = langsession[0];
            }
          }
        }
        this.setState({
          visitorSettings: visitorSetting,
          inactivePopupSession: inactivesession,
          inactivePopUpWarning: inactivewarning,
        });
      }
    }

    if (prevProps.bot_restart !== this.props.bot_restart) {
      this.setState({ ask_close: this.props.bot_restart });
    }
  }

  GetServiceAvailable = (propertyStore) => {
    var pid = "";
    if (
      localStorage.getItem(propertyStore) !== undefined &&
      localStorage.getItem(propertyStore) !== null
    ) {
      pid = localStorage.getItem(propertyStore);
    }
    if (pid !== "") {
      fetch(
        SERVICES_URL +
          "?groupId=" +
          this.props.gid +
          "&propertyId=" +
          pid +
          "&languageCode=en",
      )
        .then((response) => response.json())
        .then((json) => {
          if (json.result.length > 0) {
            this.setState({ isServiceAvailable: true });
          } else {
            this.setState({ isServiceAvailable: false });
          }
        });
    } else {
      this.setState({ isServiceAvailable: false });
    }
  };

  getAssistantName = (assistantDetail) => {
    var assistantName = "Jenni";
    if (assistantDetail !== null && assistantDetail.length > 0) {
      var data = assistantDetail.filter(
        (k) => k.locale === this.state.language,
      );
      if (data.length === 0) {
        assistantName = assistantDetail.filter((k) => k.locale === "en")[0]
          .name;
      } else {
        assistantName = data[0].name;
      }
    }
    return assistantName;
  };

  loadFormSetting(gid, pid) {
    if (gid !== null && gid !== undefined) {
      var propertyid =
        pid === undefined && this.props.pid === null ? "-1" : pid;
      fetch(
        `${process.env.REACT_APP_API_URL}/form-setting?groupId=${gid}&propertyId=${propertyid}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((json) => {
          this.setState({ formSettings: json.result });
        });
    }
  }

  render() {
    //cookies
    // Transfer-to-agent modal overlay

    const cookiesData =
      this.props.cookies_data && this.props.cookies_data.text
        ? this.getName(this.props.cookies_data.text, "cookiesText")
        : "";

    const currentAppLocale =
      AppLocale[this.state.langLocale === "" ? "en" : this.state.langLocale];
    var {
      store,
      directline,
      inputEnabled,
      user_id,
      loadingLivechat,
      agentName,
      mobile,
      botSettings,
      bookingApp,
      room_app,
      close_pop,
      opened,
      connectionError,
      inactivePopupOne,
      inactivePopupTwo,
      persistentMenuEnabled,
      resize_full,
      resize_actual,
      bearerToken,
      webSpeechPonyfill,
      micIconSetting,
      theme,
      bgImage,
    } = this.props;

    var { ask_close, menu_open, confirm_cookies, ask_bot_hide } = this.state;

    //  console.log("bg", theme, bgImage);
    const myma_logosrc =
      botSettings && botSettings.isGreyScale ? myma_logo_greyscale : myma_logo;
    if (botSettings !== undefined) {
      if (
        (theme === "ChatSuggestions" || theme === "ChatSuggestionsFull") &&
        bgImage
      ) {
        styleOptions.backgroundColor = "transparent";
      } else {
        styleOptions.backgroundColor = botSettings.colours.botBackground;
      }
      styleOptions.bubbleFromUserBackground = botSettings.colours.botUser;
      styleOptions.bubbleFromUserBorderColor = botSettings.colours.botUser;
      styleOptions.bubbleFromUserTextColor = botSettings.colours.botUserText;
      styleOptions.bubbleBackground = botSettings.colours.botBot;
      styleOptions.bubbleBorderColor = botSettings.colours.botBot;
      styleOptions.bubbleTextColor = botSettings.colours.botBotText;
      if (mobile === "true") {
        if (botSettings.hideSendBoxInMobile === true) {
          this.props.hideTypingTextBox();
        }
      } else {
        if (botSettings.hideSendBox === true) {
          this.props.hideTypingTextBox();
        }
      }

      if (
        localStorage.getItem(this.props.property_state_store) === undefined ||
        localStorage.getItem(this.props.property_state_store) === null
      ) {
        this.props.hideTypingTextBox();
      }

      if (botSettings.colours.sendBoxButton)
        styleOptions.sendBoxButtonColor = botSettings.colours.sendBoxButton;
      if (botSettings.colours.sendBoxText)
        styleOptions.sendBoxTextColor = botSettings.colours.sendBoxText;
      if (botSettings.colours.sendBoxBottomBorder) {
        styleOptions.sendBoxBorderBottom = `solid 1px ${botSettings.colours.sendBoxBottomBorder}`;
        styleOptions.sendBoxBorderTop = "";
      }
      if (botSettings.colours.sendBoxButtonFocus)
        styleOptions.sendBoxButtonColorOnFocus =
          botSettings.colours.sendBoxButtonFocus;
      if (botSettings.colours.sendBoxButtonHover)
        styleOptions.sendBoxButtonColorOnHover =
          botSettings.colours.sendBoxButtonHover;
      if (botSettings.colours.timeStamp)
        styleOptions.timestampColor = botSettings.colours.timeStamp;
      if (botSettings.colours.sendBoxPlaceHolder)
        styleOptions.sendBoxPlaceholderColor =
          botSettings.colours.sendBoxPlaceHolder;
      if (botSettings.colours.sendBoxBackground)
        styleOptions.sendBoxBackground = botSettings.colours.sendBoxBackground;

      if (botSettings.colours.suggestionBackground)
        styleOptions.suggestedActionBackground =
          botSettings.colours.suggestionBackground;

      if (botSettings.colours.suggestionText)
        styleOptions.suggestedActionTextColor =
          botSettings.colours.suggestionText;

      this.createCssRules();
    }

    return (
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Fragment>
          {" "}
          <div
            id="font-style"
            className={
              mobile == "true"
                ? `${
                    this.state.bubble_type === "Bubble"
                      ? "chat_window"
                      : "sildeopen"
                  } chat_window_mobile ${this.props.customStyle}Window`
                : `${
                    this.state.bubble_type === "Bubble"
                      ? "chat_window"
                      : "sildeopen"
                  }${this.props.resize === true ? " resize" : ""} ${
                    this.props.messenger === true ? " chat_window_msg" : ""
                  } ${this.props.isSuggestBot === true ? "window_suggest" : ""}
                ${this.props.customStyle}Window`
            }
            style={{
              // fontFamily: this.props.websiteFont || "sans-serif",
              display: opened ? "block" : "none",
              transition:
                this.props.resize === false
                  ? "all .1s ease-in"
                  : "all .2s ease-out",
            }}
          >
            {botSettings !== undefined ? (
              <>
                {botSettings.isHeaderHide === false && (
                  <Fragment>
                    {!this.props.messenger && (
                      <div
                        className={
                          mobile == "true"
                            ? `chat_header chat_header_mobile ${
                                this.props.customStyle
                              }Header ${
                                this.props.messenger === true
                                  ? " chat_header_msg"
                                  : ""
                              }`
                            : `chat_header ${this.props.customStyle}Header ${
                                this.props.resize === true
                                  ? " resize-header"
                                  : ""
                              } ${
                                this.props.messenger === true
                                  ? " chat_header_msg"
                                  : ""
                              }`
                        }
                        style={{ backgroundColor: botSettings.colours.header }}
                      >
                        <div
                          className="chat_header_menuitem"
                          onClick={this.menu_popup_open}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M12,7a2,2,0,1,0-2-2A2,2,0,0,0,12,7Zm0,10a2,2,0,1,0,2,2A2,2,0,0,0,12,17Zm0-7a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"></path>
                          </svg>
                        </div>
                        <div
                          className="chat_header_icon"
                          style={{
                            backgroundImage: `url(${botSettings.urls.icon})`,
                          }}
                        ></div>
                        <div className="chat_header_labels">
                          <span
                            className="chat_header_title"
                            style={{ color: botSettings.colours.headerText }}
                          >
                            {" "}
                            {agentName ||
                              this.getAssistantName(
                                botSettings.assistantDetails,
                              )}{" "}
                          </span>{" "}
                        </div>
                        <div
                          className={`chat_header_btn_close ${this.props.customStyle}HeaderBtn`}
                          onClick={this.close_clicked}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l6.29,6.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"></path>
                          </svg>
                        </div>
                        {this.props.customStyle === "" && mobile !== "true" ? (
                          <div
                            className="chat_header_btn_resize"
                            onClick={
                              !this.props.resize ? resize_full : resize_actual
                            }
                          >
                            {!this.props.resize ? (
                              <i className="glyphicon glyphicon-resize-full icon-2x"></i>
                            ) : (
                              <i className="glyphicon glyphicon-resize-small icon-2x"></i>
                            )}
                          </div>
                        ) : null}
                        {botSettings.multilingual ? (
                          <div
                            className={`chat_header_btn_language ${this.props.customStyle}`}
                            onClick={this.open_language_popup}
                          >
                            <svg
                              version="1.1"
                              id="anna_vital_language_icon"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 256 256"
                              fill="currentColor"
                            >
                              <path d="M62.4,101c-1.5-2.1-2.1-3.4-1.8-3.9c0.2-0.5,1.6-0.7,3.9-0.5c2.3,0.2,4.2,0.5,5.8,0.9c1.5,0.4,2.8,1,3.8,1.7	c1,0.7,1.8,1.5,2.3,2.6c0.6,1,1,2.3,1.4,3.7c0.7,2.8,0.5,4.7-0.5,5.7c-1.1,1-2.6,0.8-4.6-0.6c-2.1-1.4-3.9-2.8-5.5-4.2 C65.5,105.1,63.9,103.2,62.4,101z M40.7,190.1c4.8-2.1,9-4.2,12.6-6.4c3.5-2.1,6.6-4.4,9.3-6.8c2.6-2.3,5-4.9,7-7.7 c2-2.7,3.8-5.8,5.4-9.2c1.3,1.2,2.5,2.4,3.8,3.5c1.2,1.1,2.5,2.2,3.8,3.4c1.3,1.2,2.8,2.4,4.3,3.8c1.5,1.4,3.3,2.8,5.3,4.5 c0.7,0.5,1.4,0.9,2.1,1c0.7,0.1,1.7,0,3.1-0.6c1.3-0.5,3-1.4,5.1-2.8c2.1-1.3,4.7-3.1,7.9-5.4c1.6-1.1,2.4-2,2.3-2.7 c-0.1-0.7-1-1-2.7-0.9c-3.1,0.1-5.9,0.1-8.3-0.1c-2.5-0.2-5-0.6-7.4-1.4c-2.4-0.8-4.9-1.9-7.5-3.4c-2.6-1.5-5.6-3.6-9.1-6.2	c1-3.9,1.8-8,2.4-12.4c0.3-2.5,0.6-4.3,0.8-5.6c0.2-1.2,0.5-2.4,0.9-3.3c0.3-0.8,0.4-1.4,0.5-1.9c0.1-0.5-0.1-1-0.4-1.6	c-0.4-0.5-1-1.1-1.9-1.7c-0.9-0.6-2.2-1.4-3.9-2.3c2.4-0.9,5.1-1.7,7.9-2.6c2.7-0.9,5.7-1.8,8.8-2.7c3-0.9,4.5-1.9,4.6-3.1 c0.1-1.2-0.9-2.3-3.2-3.5c-1.5-0.8-2.9-1.1-4.3-0.9c-1.4,0.2-3.2,0.9-5.4,2.2c-0.6,0.4-1.8,0.9-3.4,1.6c-1.7,0.7-3.6,1.5-6,2.5 c-2.4,1-5,2-7.8,3.1c-2.9,1.1-5.8,2.2-8.7,3.2c-2.9,1.1-5.7,2-8.2,2.8c-2.6,0.8-4.6,1.4-6.1,1.6c-3.8,0.8-5.8,1.6-5.9,2.4	c0,0.8,1.5,1.6,4.4,2.4c1.2,0.3,2.3,0.6,3.1,0.6c0.8,0.1,1.7,0.1,2.5,0c0.8-0.1,1.6-0.3,2.4-0.5c0.8-0.3,1.7-0.7,2.8-1.1 c1.6-0.8,3.9-1.7,6.9-2.8c2.9-1,6.6-2.4,11.2-4c0.9,2.7,1.4,6,1.4,9.8c0,3.8-0.4,8.1-1.4,13c-1.3-1.1-2.7-2.3-4.2-3.6	c-1.5-1.3-2.9-2.6-4.3-3.9c-1.6-1.5-3.2-2.5-4.7-3c-1.6-0.5-3.4-0.5-5.5,0c-3.3,0.9-5,1.9-4.9,3.1c0,1.2,1.3,1.8,3.8,1.9 c0.9,0.1,1.8,0.3,2.7,0.6c0.9,0.3,1.9,0.9,3.2,1.8c1.3,0.9,2.9,2.2,4.7,3.8c1.8,1.6,4.2,3.7,7,6.3c-1.2,2.9-2.6,5.6-4.1,8	c-1.5,2.5-3.4,5-5.5,7.3c-2.2,2.4-4.7,4.8-7.7,7.2c-3,2.5-6.6,5.1-10.8,7.8c-4.3,2.8-6.5,4.7-6.5,5.6C35,192.1,37,191.7,40.7,190.1z M250.5,81.8v165.3l-111.6-36.4L10.5,253.4V76.1l29.9-10V10.4l81.2,28.7L231.3,2.6v73.1L250.5,81.8z M124.2,50.6L22.3,84.6v152.2 l101.9-33.9V50.6L124.2,50.6z M219.4,71.9V19L138.1,46L219.4,71.9z M227,201.9L196.5,92L176,85.6l-30.9,90.8l18.9,5.9l5.8-18.7 l31.9,10l5.7,22.3L227,201.9z M174.8,147.7l22.2,6.9l-10.9-42.9L174.8,147.7z" />
                            </svg>
                          </div>
                        ) : null}
                        <div
                          className={`chat_header_btn_end ${this.props.customStyle}HeaderBtn d-none`}
                          onClick={this.end_clicked}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M19,11H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"></path>
                          </svg>
                        </div>
                        {this.props.customStyle !== "" ? (
                          <div
                            className={`chat_header_btn_end ${this.props.customStyle}`}
                            style={{
                              backgroundImage: `url(${botSettings.urls.refreshIcon}`,
                            }}
                            onClick={this.refresh}
                          >
                            {" "}
                          </div>
                        ) : null}
                      </div>
                    )}
                    {this.props.isSuggestBot && mobile === "true" ? (
                      <div className="chat_header chat_header_mobile header-fullview">
                        <div
                          className="clickbooknow"
                          onClick={() =>
                            this.openBooknowUrl(
                              this.props.micIconSetting.bookNowButtonUrl,
                            )
                          }
                        >
                          {this.props.micIconSetting.bookNowButtonText}
                        </div>
                        <div
                          className={`chat_header_btn_close_fullview ${this.props.customStyle}HeaderBtn`}
                          onClick={this.closeMessger}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l6.29,6.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"></path>
                          </svg>
                        </div>
                      </div>
                    ) : null}
                  </Fragment>
                )}
                {menu_open ? (
                  <PersistentMenu
                    mobile={mobile}
                    menuOpen={this.menu_popup_Close}
                    persistentMenu={this.state.persistentMenuData}
                    persistentMenuEnabled={persistentMenuEnabled}
                    handleMenuClick={this.handleMenuClick}
                    botSettings={botSettings}
                    cookiesDetail={this.cookies_details}
                    botSite={this.bob_site}
                  ></PersistentMenu>
                ) : (
                  ""
                )}
                {!this.props.isSuggestBot && ask_close ? (
                  <div
                    className={`chat_box_popup_new`}
                    onClick={() => {
                      this.setState({ ask_close: false });
                      if (this.props.messenger) {
                        this.props.bot_restartClick();
                      }
                    }}
                  >
                    <div
                      className={`endchat_popup ${
                        ask_close ? "area" : "closepop"
                      }`}
                    >
                      <h1>
                        {""}
                        <IntlMessages id="chat.end" />
                        {""}
                      </h1>
                      <p className="endchat_text">
                        <IntlMessages id="chat.endtext" />
                      </p>
                      <button
                        className="endchat_button"
                        onClick={this.close_confirmed}
                      >
                        {""}
                        <IntlMessages id="chat.end" />
                        {""}
                      </button>
                      <button
                        className="cancelchat_button"
                        onClick={this.close_cancel}
                      >
                        {""}
                        <IntlMessages id="chat.cancel" />
                        {""}
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {this.props.isSuggestBot && ask_close ? (
                  <div
                    className="chat_popup_area_restart"
                    style={{ bottom: mobile === "true" ? "90px" : "" }}
                  >
                    <RestartConversation
                      mobile={mobile}
                      isOpen={ask_close}
                      close_confirmed={() => {
                        this.close_confirmed();
                        this.props.restartIconclick();
                      }}
                      close_cancel={() => {
                        this.close_cancel();
                        this.props.restartIconclick();
                      }}
                    ></RestartConversation>
                  </div>
                ) : (
                  ""
                )}
                {this.state.open_ZChatfeedback_popup && (
                  <FeedbackPopup
                    data={this.state.zChatfeedbackData}
                    setZchatFeedback={this.setZchatFeedback}
                    conid={this.props.directline.conversationId}
                    gid={this.props.gid}
                    formSettings={this.state.formSettings}
                    bearerToken={bearerToken}
                    theme={this.props.messengerTheme}
                    locale={this.state.language}
                  ></FeedbackPopup>
                )}
                {this.state.open_language_popup && (
                  <div className="chat_box_popup_new">
                    <div
                      className={`switch_language_popup ${
                        this.state.open_language_popup ? "area" : "closepop"
                      }`}
                    >
                      <div
                        className={
                          mobile == "true"
                            ? `switch_language_popup_header chat_header_mobile`
                            : `switch_language_popup_header`
                        }
                        style={{ backgroundColor: botSettings.colours.header }}
                      >
                        <div
                          className="header_icon"
                          onClick={this.close_language_popup}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l6.29,6.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"></path>
                          </svg>
                        </div>
                        <div
                          className="header_text"
                          style={{ color: botSettings.colours.headerText }}
                        >
                          <IntlMessages id="switch.language" />
                        </div>
                      </div>
                      <div className="switch_language_popup_body">
                        <div
                          className={`switch_language_popup_body ${
                            mobile == "true"
                              ? "popup_items_mobile"
                              : "popup_items"
                          }`}
                        >
                          {botSettings.multilingual
                            ? this.state.languageOptions.map((elem, index) => {
                                return (
                                  <button
                                    className="popupmenu"
                                    onClick={() =>
                                      this.handleChangeLanguage(elem.id, true)
                                    }
                                    key={index}
                                  >
                                    <span className="text">{elem.desc}</span>
                                    {this.state.language === elem.id ? (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ color: "#19af19" }}
                                      >
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"></path>
                                      </svg>
                                    ) : (
                                      ""
                                    )}
                                  </button>
                                );
                              })
                            : this.state.languageOptions
                                .filter((i) =>
                                  i.id.includes(this.state.language),
                                )
                                .map((elem, index) => {
                                  return (
                                    <button className="popupmenu" key={index}>
                                      <span className="text">{elem.desc}</span>
                                      {this.state.language === elem.id ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="currentColor"
                                          style={{ color: "#19af19" }}
                                        >
                                          <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"></path>
                                        </svg>
                                      ) : (
                                        ""
                                      )}
                                    </button>
                                  );
                                })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.open_property_popup && (
                  <PropertyPopup
                    close_property_popup={this.close_property_popup}
                    open_property_popup={this.state.open_property_popup}
                    pid={this.props.pid}
                    gid={this.props.gid}
                    close_pop={close_pop}
                    room_app={room_app}
                    bookingApp={bookingApp}
                    botSettings={botSettings}
                    isCheckedAvailability={this.props.isCheckedAvailability}
                    hideRoomDetail={this.props.hideRoomDetail}
                    mobile={mobile}
                    GetServiceAvailable={this.GetServiceAvailable}
                    property_state_store={this.props.property_state_store}
                    setPropertyPopUp={this.props.setPropertyPopUp}
                    loadFormSetting={this.loadFormSetting.bind(this)}
                  ></PropertyPopup>
                )}
                {this.state.open_availblity_popup && (
                  <CheckAvailablity
                    api={this.props.api}
                    data={this.state.availblityData}
                    open_availblity_popup={this.state.open_availblity_popup}
                    closeAvailblityForm={this.closeAvailblityForm}
                    botSettings={botSettings}
                    lang={this.state.language}
                    addLinks={this.addLinks}
                    gid={this.props.gid}
                    pid={this.props.pid}
                    messengerSetting={this.props.messengerSettings}
                    buttonColor={this.props.messengerSettings.color}
                  ></CheckAvailablity>
                )}
                {this.state.open_service_popup && (
                  <ServicePopup
                    mobile={mobile}
                    open_service_popup={this.state.open_service_popup}
                    close_serivce_popup={this.close_service_popup}
                    pid={this.props.pid}
                    gid={this.props.gid}
                    conversation_id={this.props.directline.conversationId}
                  ></ServicePopup>
                )}
                {/* {this.state.open_simple_action_popup && (
                  <SalesForceActionPopup
                    onClose={this.close_case_form_popup}
                    lang={this.state.language}
                    buttonColor={this.props.messengerSettings?.color}
                    onCreateCase={async () => {
                      console.log("Simple action submitted");
                      const prefill = this.state.simpleActionPrefill || {};
                      this.setState(
                        {
                          open_simple_action_popup: false,
                          open_case_form_popup: true,
                          pendingCaseFormPrefill: prefill,
                        },
                        async () => {
                          // Wait for popup to render, then prefill
                          if (
                            this.caseFormPopupRef &&
                            this.caseFormPopupRef.current &&
                            typeof this.caseFormPopupRef.current
                              .prefillFields === "function"
                          ) {
                            await this.caseFormPopupRef.current.prefillFields(
                              prefill,
                            );
                            this.setState({
                              caseFormPrefillLoading: false,
                              pendingCaseFormPrefill: null,
                            });
                          }
                        },
                      );
                    }}
                    userName={this.props.prechatdata?.userName || ""}
                    userEmail={this.props.prechatdata?.userEmail || ""}
                    propertyName={this.props.prechatdata?.propertyName || ""}
                    chainName={this.props.prechatdata?.chainName || ""}
                    chatHistory={(() => {
                      let storeState = null;
                      if (
                        this.props.store &&
                        typeof this.props.store.getState === "function"
                      ) {
                        storeState = this.props.store.getState();
                      } else if (
                        this.props.bookingApp &&
                        this.props.bookingApp.callbacks &&
                        typeof this.props.bookingApp.callbacks.getStore ===
                          "function"
                      ) {
                        storeState = this.props.bookingApp.callbacks
                          .getStore()
                          .getState();
                      }
                      if (storeState) {
                        try {
                          return require("./ChatStore").getChatHistoryForAgent(
                            storeState,
                          );
                        } catch (e) {
                          return "";
                        }
                      }
                      return "";
                    })()}
                    userType={this.props.prechatdata?.userType || ""}
                  />
                )} */}

                {this.state.open_case_form_popup && (
                  <CaseFormPopup
                    ref={this.caseFormPopupRef}
                    onSubmit={(data) =>
                      console.log("Case form submitted:", data)
                    }
                    onClose={this.close_case_form_popup}
                    accountId={this.props.prechatdata?.accountId}
                    contactId={this.props.prechatdata?.contactId}
                    buttonColor={this.props.messengerSettings?.color}
                    theme={this.props.messengerTheme}
                    directline={this.props.directline}
                    gid={this.props.gid}
                    iid={this.props.iid}
                    pid={this.props.pid}
                    vid={this.props.vid}
                    sid={this.props.sid}
                    lang={this.state.language}
                    loadClosedCases={this.close_case_loader}
                    chatHistory={(() => {
                      let storeState = null;
                      if (
                        this.props.store &&
                        typeof this.props.store.getState === "function"
                      ) {
                        storeState = this.props.store.getState();
                      } else if (
                        this.props.bookingApp &&
                        this.props.bookingApp.callbacks &&
                        typeof this.props.bookingApp.callbacks.getStore ===
                          "function"
                      ) {
                        storeState = this.props.bookingApp.callbacks
                          .getStore()
                          .getState();
                      }
                      if (storeState) {
                        try {
                          return require("./ChatStore").getChatHistoryForAgent(
                            storeState,
                          );
                        } catch (e) {
                          return "";
                        }
                      }
                      return "";
                    })()}
                  />
                )}
                <div
                  className="chat_box_popup_new"
                  id="feedback_popup"
                  style={{ display: "none" }}
                >
                  <ThumbFeedback
                    handleFeedBackResponse={(e, name, phone, email, formId) =>
                      this.handleFeedBackResponse(e, name, phone, email, formId)
                    }
                    handleCancelFeedbackResponse={() =>
                      this.handleCancelFeedbackResponse()
                    }
                    locale={this.state.language}
                    changeleaveFeedbackMessage={(e) =>
                      this.setState({ leaveFeedbackMessage: e })
                    }
                    buttonColor={this.props.messengerSettings.color}
                    pid={this.props.pid}
                    gid={this.props.gid}
                    bookingApp={this.props.bookingApp}
                    bearerToken={bearerToken}
                    conid={this.props.directline.conversationId}
                    iid={this.props.iid}
                    formSettings={this.state.formSettings}
                    theme={this.props.messengerTheme}
                  ></ThumbFeedback>
                </div>
                <div className="chat_main">
                  <div
                    className="chat_popup_box"
                    style={{
                      paddingTop: this.props.messenger === true ? "0em" : "",
                    }}
                  >
                    {/* {confirm_cookies && this.props.messenger && cookiesData ? (
                      <div
                        className="chat_popup_bg"
                        style={{ zIndex: 7 }}
                      >
                        <div className="chat_popup_text" style={{ width: "85%" }} >

                          <div
                            className="cookies-text" >
                            <span onClick={(e) => this.handleLinkClick(e)}>{ReactHtmlParser(cookiesData)}</span>

                          </div>

                        </div>
                        <div
                          className=" mr-2 btn_popup"
                          onClick={this.cookies_understood}
                        >
                          {" "}
                          &times;{" "}
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}
                    {this.state.isCookiesHide === false &&
                    this.props.messenger &&
                    cookiesData ? (
                      <div className="chat_popup_bg" style={{ zIndex: 7 }}>
                        <div
                          className="chat_popup_text"
                          style={{ width: "85%" }}
                        >
                          <div className="cookies-text">
                            <span onClick={(e) => this.handleLinkClick(e)}>
                              {ReactHtmlParser(cookiesData)}
                            </span>
                          </div>
                        </div>
                        <div
                          className="btn mr-2 btn_popup "
                          onClick={this.cookies_understood}
                        >
                          {" "}
                          &times;{" "}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {this.state.isOpenModal ? (
                    <div className="chat_popup_area" onClick={this.closeModal}>
                      <CookiePopup
                        isOpen={this.state.isOpenModal}
                        onClose={this.closeModal}
                        content={this.state.modalContent}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {ask_bot_hide ? (
                  <div
                    className="chat_popup chat_popup_bar"
                    onClick={() => this.setState({ ask_bot_hide: false })}
                    style={{ zIndex: 10, padding: "0.5em", display: "block" }}
                  >
                    <div className="chat_popup_body">
                      <div
                        className="chat_popup_text text-center"
                        style={{ width: "100%" }}
                      >
                        {" "}
                        <IntlMessages id="chat.hidebot.text" />{" "}
                      </div>
                      <div
                        className="btn btn-outline-success mr-2 mt-2 btn_popup"
                        onClick={this.close_bot_ask_hide}
                      >
                        {" "}
                        <IntlMessages id="chat.minimize" />{" "}
                      </div>
                      <div
                        className="btn btn-outline-primary mr-2 mt-2 btn_popup"
                        onClick={this.hide_bot_confirm}
                      >
                        {" "}
                        <IntlMessages id="chat.hide" />{" "}
                      </div>
                      <div
                        className="btn btn-outline-danger mr-2 mt-2 btn_popup"
                        onClick={this.end_clicked}
                      >
                        {" "}
                        <IntlMessages id="chat.restart" />{" "}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className={`chat_box_outer${
                    this.props.messenger ? " pt-0" : ""
                  }`}
                  style={{
                    paddingBottom:
                      this.props.gid ===
                        "df96582a-c1d2-4be7-abc5-af820013452c" ||
                      this.props.gid ===
                        "56431a33-0783-46e0-ab83-afb0016d3b58" ||
                      this.props.gid ===
                        "a7e06370-a3bc-43ef-ba88-afb100137eca" ||
                      this.props.gid ===
                        "3af8dc3a-2be5-456e-82b5-afc60145e4ad" ||
                      this.props.gid ===
                        "af402810-8902-473b-a487-b04301549dac" ||
                      this.props.gid ===
                        "4f042507-dc0c-4dfc-abe6-b07a01689612" ||
                      this.props.gid ===
                        "4d44c1aa-dc7c-415f-80e8-b08f0149ad66" ||
                      this.props.gid ===
                        "c1032caf-7739-4567-932d-b0b40050d671" ||
                      this.props.gid === "87c8de62-cc9f-4c08-a6f5-b1b200479cfa"
                        ? this.props.isSuggestBot === true
                          ? "0px"
                          : "31px"
                        : this.props.isSuggestBot === true
                          ? "0px"
                          : "29px",
                  }}
                >
                  {botSettings.inactivePopUpWarning &&
                    botSettings.inactivePopUpWarning.enabled === true &&
                    inactivePopupOne && (
                      <div
                        className="chat_box_connection_error"
                        style={{ display: inactivePopupOne ? "block" : "none" }}
                      >
                        <div className="chat_box_connection_error_inner">
                          <span
                            className="connection_error_icon"
                            role="img"
                            aria-label="Warning"
                          >
                            {" "}
                            ⚠️{" "}
                          </span>{" "}
                          <p />
                          <span className="connection_error_text_small">
                            {this.state.inactivePopUpWarning?.message}
                            {/* {this.state.language === "en" ? (
                              botSettings.inactivePopUpWarning.message
                            ) : (
                              <Translate
                                input={botSettings.inactivePopUpWarning.message}
                                lang={this.state.language}
                              />
                            )} */}
                          </span>{" "}
                          <br />
                          <div
                            className="btn btn-outline-muted mt-4 connection_error_restart"
                            onClick={this.popupclose_confirmed}
                          >
                            {" "}
                            {this.state.inactivePopUpWarning?.buttonText}
                            {/* {this.state.language === "en" ? (
                              "Close"
                            ) : (
                              <Translate
                                input={"Close"}
                                lang={this.state.language}
                              />
                            )}{" "} */}
                          </div>
                        </div>
                      </div>
                    )}
                  {this.state.showTransferLoader && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255,255,255,0.7)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="modern-spinner"></div>
                    </div>
                  )}
                  {this.state.showTransferModal && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.35)",
                        zIndex: 1200,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: 8,
                          boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
                          padding: "32px 32px 24px 32px",
                          minWidth: 280,
                          maxWidth: 340,
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ fontSize: 20, marginBottom: 24 }}>
                          You are being transferred to a live agent.
                          <br />A new chat window will open on the right side of
                          your browser.
                        </div>
                        <button
                          className="btn btn-primary"
                          style={{
                            minWidth: 120,
                            backgroundColor: this.props.messengerSettings.color,
                            borderColor: this.props.messengerSettings.color,
                            color: "#fff",
                          }}
                          onClick={this.handleTransferModalOk}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}
                  {this.state.caseFormPrefillLoading && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(255,255,255,0.7)",
                        zIndex: 2000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="modern-spinner" aria-label="Loading" />
                    </div>
                  )}
                  {botSettings.inactivePopUpSession &&
                    botSettings.inactivePopUpSession.enabled === true &&
                    inactivePopupTwo && (
                      <div
                        className="chat_box_connection_error"
                        style={{ display: inactivePopupTwo ? "block" : "none" }}
                      >
                        <div className="chat_box_connection_error_inner">
                          <span
                            className="connection_error_icon"
                            role="img"
                            aria-label="Warning"
                          >
                            {" "}
                            ⚠️{" "}
                          </span>{" "}
                          <p />
                          <span className="connection_error_text_small">
                            {this.state.inactivePopupSession?.message}
                            {/* {this.state.language === "en" ? (
                              botSettings.inactivePopUpSession.message
                            ) : (
                              <Translate
                                input={botSettings.inactivePopUpSession.message}
                                lang={this.state.language}
                              />
                            )} */}
                          </span>{" "}
                          <br />
                          <div
                            className="btn btn-outline-muted mt-4 connection_error_restart"
                            onClick={this.close_confirmed}
                          >
                            {" "}
                            {this.state.inactivePopupSession?.buttonText}
                            {/* {this.state.language === "en" ? (
                              "Restart"
                            ) : (
                              <Translate
                                input={"Restart"}
                                lang={this.state.language}
                              />
                            )}{" "} */}
                          </div>
                        </div>
                      </div>
                    )}
                  <div
                    className="chat_box_connection_error"
                    style={{ display: connectionError ? "block" : "none" }}
                  >
                    <div className="chat_box_connection_error_inner">
                      <span
                        className="connection_error_icon"
                        role="img"
                        aria-label="Warning"
                      >
                        {" "}
                        ⚠️{" "}
                      </span>{" "}
                      <p />
                      <span className="connection_error_text_small">
                        Your session has expired due to inactivity
                      </span>{" "}
                      <br />
                      <div
                        className="btn btn-outline-muted mt-4 connection_error_restart"
                        onClick={this.close_confirmed}
                      >
                        {" "}
                        Restart{" "}
                      </div>
                    </div>
                  </div>
                  {/* {this.props.moveTop === true && (
                    <div
                      id="kt_scrolltop"
                      className="scrolltop"
                      onClick={() => this.movetotop()}
                    >
                      <span className="glyphicon glyphicon-chevron-up"></span>
                    </div>
                  )} */}
                  <div
                    key={bgImage || "default-bg"}
                    className={`chat_box ${this.props.customStyle}`}
                    id="chat_box"
                    style={{
                      backgroundImage: bgImage ? `url(${bgImage})` : "none",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    {directline && !loadingLivechat ? (
                      <ReactWebChat
                        // sendTypingIndicator={true}
                        locale={this.state.language}
                        directLine={directline}
                        googleAnalytics={
                          this.state.googleAnalytics.utmSource !== undefined
                            ? this.state.googleAnalytics
                            : undefined
                        }
                        styleOptions={styleOptions}
                        store={store}
                        disabled={!inputEnabled}
                        userID={user_id}
                        typingIndicatorMiddleware={ChatWindowTypingIndicator}
                        cardActionMiddleware={ChatWindowCardAction}
                        webSpeechPonyfillFactory={webSpeechPonyfill}
                        attachmentMiddleware={AttachmentMiddleware(
                          this.props.api,
                          botSettings,
                          directline,
                          this.props.gid,
                          this.props.iid,
                          this.addLinks,
                          this.availblityForm,
                          this.OpenServicePopUp,
                          this.props.inZenDesk,
                          this.props.bookingApp,
                          this.props.imagedomain,
                          this.props.parent_location,
                          this.props.messengerSettings,
                          this.state.googleAnalytics.utmSource !== undefined
                            ? this.state.googleAnalytics
                            : undefined,
                          this.openCaseForm,
                          this.handleStartChat,
                          this.close_confirmed,
                          this.handleSingleDislike,
                          this.handleMultipleDislikes,
                        )}
                      />
                    ) : this.props.customStyle !== "" ? (
                      <div id="spinner" className="container">
                        <div className="loading"></div>
                      </div>
                    ) : (
                      <div className="chat_loading"></div>
                    )}
                    {
                      //@TODO automate extension management
                      this.props.extensions[CHAT_SUGGESTION_EXT_ID] ? (
                        <ChatSuggestionExtension
                          suggestions={
                            this.props.extensions[CHAT_SUGGESTION_EXT_ID]
                          }
                          api={this.props.extensions._api}
                          styling={this.props.botSettings}
                          opened={opened}
                        />
                      ) : (
                        ""
                      )
                    }
                    {
                      //@TODO automate extension management
                      this.props.extensions[CHAT_AUTOCOMPLETE_EXT_ID] ? (
                        <AutoCompleteExtension
                          suggestions={
                            this.props.extensions[CHAT_AUTOCOMPLETE_EXT_ID]
                          }
                          api={this.props.extensions._api}
                          styling={this.props.botSettings}
                          opened={opened}
                          imagedomain={this.props.imagedomain}
                        />
                      ) : (
                        ""
                      )
                    }
                    {this.props.extensions[WEB_VIEW_EXT_ID] ? (
                      <WebViewExtension
                        webview={this.props.extensions[WEB_VIEW_EXT_ID]}
                        api={this.props.extensions._api}
                        styling={this.props.botSettings}
                        opened={opened}
                        messenger={this.props.messenger}
                        isSuggestBot={this.props.isSuggestBot}
                        theme={this.props.messengerTheme}
                        lang={this.state.language}
                      />
                    ) : (
                      ""
                    )}
                    {this.props.extensions[WEB_VIEW_EX_EXT_ID] ? (
                      <WebViewExternalExtension
                        webviewExt={this.props.extensions[WEB_VIEW_EX_EXT_ID]}
                        api={this.props.extensions._api}
                        styling={this.props.botSettings}
                        opened={opened}
                        isSuggestBot={this.props.isSuggestBot}
                      />
                    ) : (
                      ""
                    )}
                  </div>{" "}
                  {this.state.visitorPopupState === true &&
                    botSettings.visitorPopup === true && (
                      <div
                        className={`chat_box_visitor_details ${
                          this.props.isSuggestBot === true
                            ? "suggest-visitorpop"
                            : ""
                        }`}
                        id="chat_box_visitor"
                        onClick={(e) => {
                          const anyMandatoryField =
                            this.state.visitorSettings?.fields?.some(
                              (field) => field.mandatory,
                            );
                          if (
                            this.visitorPopupRef.current &&
                            !this.visitorPopupRef.current.contains(e.target) &&
                            !anyMandatoryField
                          ) {
                            this.setState({ visitorPopupState: false });
                          }
                        }}
                      >
                        <div
                          className="chat_box_visitor_details_inner"
                          style={{ borderColor: botSettings.colours.botBot }}
                          ref={this.visitorPopupRef}
                        >
                          {this.state.visitorSettings !== null && (
                            <Form onSubmit={(e) => this.save_visitor(e)}>
                              <h4>
                                {" "}
                                {this.state.visitorSettings.title}
                                {/* {this.state.language === "en" ? (
                                  botSettings.visitorSettings.title
                                ) : (
                                  <Translate
                                    input={botSettings.visitorSettings.title}
                                    lang={this.state.language}
                                    instructions={
                                      botSettings?.languageInstructions
                                    }
                                  />
                                )} */}
                              </h4>
                              {ReactHtmlParser(
                                this.state.visitorSettings.subTitle,
                              )}
                              {/* {this.state.language === "en" ? (
                                ReactHtmlParser(
                                  botSettings.visitorSettings.subTitle
                                )
                              ) : (
                                <Translate
                                  input={botSettings.visitorSettings.subTitle}
                                  lang={this.state.language}
                                  instructions={
                                    botSettings?.languageInstructions
                                  }
                                />
                              )} */}
                              {this.state.visitorSettings.fields.map(
                                (elem, fIndex) => {
                                  if (elem.field === "Name") {
                                    return (
                                      <Fragment key={fIndex}>
                                        <FormGroup>
                                          <FormattedMessage
                                            id="placeholder.name"
                                            defaultMessage={"Name"}
                                          >
                                            {(placeholder) => (
                                              <Input
                                                bsSize="sm"
                                                type="text"
                                                name="name"
                                                value={this.state.name}
                                                placeholder={
                                                  elem.placeHolder === null
                                                    ? placeholder
                                                    : elem.placeHolder
                                                }
                                                onChange={
                                                  this.handleVisitorNameChange
                                                }
                                                required={elem.mandatory}
                                              ></Input>
                                            )}
                                          </FormattedMessage>
                                        </FormGroup>
                                      </Fragment>
                                    );
                                  } else if (elem.field === "FirstName") {
                                    return (
                                      <Fragment key={fIndex}>
                                        <FormGroup>
                                          <FormattedMessage
                                            id="placeholder.firstName"
                                            defaultMessage={"First Name"}
                                          >
                                            {(placeholder) => (
                                              <Input
                                                bsSize="sm"
                                                type="text"
                                                name="FirstName"
                                                value={this.state.firstName}
                                                placeholder={
                                                  elem.placeHolder === null
                                                    ? placeholder
                                                    : elem.placeHolder
                                                }
                                                onChange={
                                                  this
                                                    .hadleVisitorFirstNameChange
                                                }
                                                required={elem.mandatory}
                                              ></Input>
                                            )}
                                          </FormattedMessage>
                                        </FormGroup>
                                      </Fragment>
                                    );
                                  } else if (elem.field === "LastName") {
                                    return (
                                      <Fragment key={fIndex}>
                                        <FormGroup>
                                          <FormattedMessage
                                            id="placeholder.lastName"
                                            defaultMessage={"Last Name"}
                                          >
                                            {(placeholder) => (
                                              <Input
                                                bsSize="sm"
                                                type="text"
                                                name="lastName"
                                                value={this.state.lastName}
                                                placeholder={
                                                  elem.placeHolder === null
                                                    ? placeholder
                                                    : elem.placeHolder
                                                }
                                                onChange={
                                                  this
                                                    .hadleVisitorLastNameChange
                                                }
                                                required={elem.mandatory}
                                              ></Input>
                                            )}
                                          </FormattedMessage>
                                        </FormGroup>
                                      </Fragment>
                                    );
                                  } else if (elem.field === "Email") {
                                    return (
                                      <Fragment key={fIndex}>
                                        <FormGroup>
                                          <FormattedMessage
                                            id="placeholder.email"
                                            defaultMessage={"Email"}
                                          >
                                            {(placeholder) => (
                                              <Input
                                                bsSize="sm"
                                                type="email"
                                                name="email"
                                                placeholder={
                                                  elem.placeHolder === null
                                                    ? placeholder
                                                    : elem.placeHolder
                                                }
                                                value={this.state.email}
                                                onChange={
                                                  this.handleVisitorEmailChange
                                                }
                                                required={elem.mandatory}
                                              ></Input>
                                            )}
                                          </FormattedMessage>
                                        </FormGroup>
                                      </Fragment>
                                    );
                                  } else if (elem.field === "PhoneNumber") {
                                    return (
                                      <Fragment key={fIndex}>
                                        <FormGroup>
                                          <FormattedMessage
                                            id="placeholder.phoneNumber"
                                            defaultMessage={"Phone Number"}
                                          >
                                            {(placeholder) => (
                                              <Input
                                                bsSize="sm"
                                                type="text"
                                                name=""
                                                placeholder={
                                                  elem.placeHolder === null
                                                    ? placeholder
                                                    : elem.placeHolder
                                                }
                                                value={this.state.phoneNumber}
                                                onChange={
                                                  this
                                                    .handleVisitorPhoneNumerChange
                                                }
                                                required={elem.mandatory}
                                              ></Input>
                                            )}
                                          </FormattedMessage>
                                        </FormGroup>
                                      </Fragment>
                                    );
                                  } else if (elem.field === "ZipCode") {
                                    return (
                                      <Fragment key={fIndex}>
                                        <FormGroup>
                                          <FormattedMessage
                                            id="placeholder.zipCode"
                                            defaultMessage={"Zip Code"}
                                          >
                                            {(placeholder) => (
                                              <Input
                                                bsSize="sm"
                                                type="number"
                                                name="zipCode"
                                                value={this.state.zipCode}
                                                placeholder={
                                                  elem.placeHolder === null
                                                    ? placeholder
                                                    : elem.placeHolder
                                                }
                                                onChange={
                                                  this.hadleVisitorZipCodeChange
                                                }
                                                required={elem.mandatory}
                                              ></Input>
                                            )}
                                          </FormattedMessage>
                                        </FormGroup>
                                      </Fragment>
                                    );
                                  }
                                },
                              )}
                              <FormGroup>
                                <CustomInput
                                  id="consent"
                                  type="checkbox"
                                  name="consentGiven"
                                  checked={this.state.consentGiven}
                                  onChange={this.handleVisitorCheckBoxChange}
                                  label={
                                    this.state.visitorSettings.checkboxText !==
                                    null ? (
                                      ReactHtmlParser(
                                        this.state.visitorSettings.checkboxText,
                                      )
                                    ) : // this.state.language === "en" ? (
                                    //   ReactHtmlParser(
                                    //     botSettings.visitorSettings
                                    //       .checkboxText
                                    //   )
                                    // ) : (
                                    //   <Translate
                                    //     input={
                                    //       botSettings.visitorSettings
                                    //         .checkboxText
                                    //     }
                                    //     lang={this.state.language}
                                    //   />
                                    // )
                                    this.state.language === "en" ? (
                                      "I want to receive offers or promotions from the hotel by email or text messages."
                                    ) : (
                                      <Translate
                                        input={
                                          "I want to receive offers or promotions from the hotel by email or text messages."
                                        }
                                        lang={this.state.language}
                                      />
                                    )
                                  }
                                ></CustomInput>
                              </FormGroup>
                              <Button
                                style={{
                                  backgroundColor: botSettings.colours.botBot,
                                  color: botSettings.colours.botBotText,
                                }}
                                disabled={this.state.isButtonDisable}
                              >
                                <Fragment>
                                  <svg
                                    className=""
                                    height="28"
                                    viewBox="0 0 45.7 33.8"
                                    width="28"
                                  >
                                    <path
                                      clipRule="evenodd"
                                      d="M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z"
                                    ></path>
                                  </svg>
                                  {this.state.visitorSettings.buttonText}
                                  {/* {this.state.language === "en" ? (
                                    botSettings.visitorSettings.buttonText
                                  ) : (
                                    <Translate
                                      input={
                                        botSettings.visitorSettings.buttonText
                                      }
                                      lang={this.state.language}
                                    />
                                  )} */}
                                </Fragment>
                              </Button>
                            </Form>
                          )}
                        </div>
                      </div>
                    )}
                </div>
                {this.props.customStyle === "" &&
                this.props.isSuggestBot === false ? (
                  <div
                    className={
                      mobile == "true"
                        ? `chat_footer chat_footer_mobile${
                            this.props.messenger ? " chat_footer_msg" : ""
                          }`
                        : `chat_footer ${
                            this.props.resize === true ? " resize-footer" : ""
                          } ${this.props.messenger ? " chat_footer_msg" : ""}`
                    }
                    style={{
                      backgroundColor: botSettings.colours.botBackground,
                      color: styleOptions.timestampColor,
                    }}
                  >
                    {this.props.messenger ? (
                      <Fragment>
                        {this.props.messengerSettings &&
                          this.props.messengerSettings.isFooterHide ===
                            false && (
                            <div className="poweredby">
                              {!(
                                this.props.groupData &&
                                this.props.groupData?.group?.poweredByLogo &&
                                this.props.groupData?.group?.poweredByLogoBot
                              ) ? (
                                <div
                                  className="poweredby"
                                  onClick={() =>
                                    this.bob_site(
                                      "https://www.myma.ai/?utm_source=messenger&utm_medium=branding&utm_campaign=clicks",
                                    )
                                  }
                                >
                                  <span>
                                    <img src={myma_logosrc} width={120}></img>
                                  </span>
                                </div>
                              ) : (
                                <a
                                  href={
                                    this.props.groupData?.group?.poweredByURL
                                  }
                                  target="_blank"
                                >
                                  <img
                                    src={
                                      this.props.groupData?.group
                                        ?.poweredByLogoBot === null &&
                                      this.props.groupData?.group
                                        ?.poweredByLogoBot === ""
                                        ? this.props.groupData?.group
                                            ?.poweredByLogo
                                        : this.props.groupData?.group
                                            ?.poweredByLogoBot
                                    }
                                    style={{ width: "120px" }}
                                    alt="Myma Logo"
                                  />
                                </a>
                              )}
                            </div>
                          )}
                      </Fragment>
                    ) : (
                      <div className="poweredby">
                        {!(
                          this.props.groupData &&
                          this.props.groupData?.group?.poweredByLogo &&
                          this.props.groupData?.group?.poweredByLogoBot
                        ) ? (
                          <div
                            className="poweredby"
                            onClick={() =>
                              this.bob_site(
                                "https://www.myma.ai/?utm_source=messenger&utm_medium=branding&utm_campaign=clicks",
                              )
                            }
                          >
                            {" "}
                            <img src={myma_logosrc} width={120}></img>
                            {/* {this.props.gid !==
                              "df96582a-c1d2-4be7-abc5-af820013452c" &&
                              this.props.gid !==
                              "56431a33-0783-46e0-ab83-afb0016d3b58" &&
                              this.props.gid !==
                              "a7e06370-a3bc-43ef-ba88-afb100137eca" &&
                              this.props.gid !==
                              "3af8dc3a-2be5-456e-82b5-afc60145e4ad" &&
                              this.props.gid !==
                              "af402810-8902-473b-a487-b04301549dac" &&
                              this.props.gid !==
                              "4f042507-dc0c-4dfc-abe6-b07a01689612" &&
                              this.props.gid !==
                              "4d44c1aa-dc7c-415f-80e8-b08f0149ad66" &&
                              this.props.gid !==
                              "c1032caf-7739-4567-932d-b0b40050d671" &&
                              this.props.gid !==
                              "87c8de62-cc9f-4c08-a6f5-b1b200479cfa" &&
                              this.props.gid !==
                              "0611e452-5776-41dd-8f9a-b12d003f5172" &&
                              this.props.gid !==
                              "0e6ce08b-0d8f-4853-a131-b28300b87b5d" && (
                                <Fragment> */}
                            {/* <span
                                className="empoweredText"
                                style={{
                                  fontSize: "8px",
                                  verticalAlign: "sub",
                                  color: "blue",
                                }}
                              >
                                Empowered by
                              </span>{" "} */}
                            {/* <img src={myma_logosrc} width={120}></img> */}
                            {/* </Fragment>
                              )} */}
                            {/* <span
                              style={{ fontSize: "10px", verticalAlign: "sub" }}
                            >
                              {(this.props.gid ===
                                "df96582a-c1d2-4be7-abc5-af820013452c" ||
                                this.props.gid ===
                                  "56431a33-0783-46e0-ab83-afb0016d3b58" ||
                                this.props.gid ===
                                  "a7e06370-a3bc-43ef-ba88-afb100137eca" ||
                                this.props.gid ===
                                  "3af8dc3a-2be5-456e-82b5-afc60145e4ad" ||
                                this.props.gid ===
                                  "af402810-8902-473b-a487-b04301549dac" ||
                                this.props.gid ===
                                  "4f042507-dc0c-4dfc-abe6-b07a01689612" ||
                                this.props.gid ===
                                  "4d44c1aa-dc7c-415f-80e8-b08f0149ad66" ||
                                this.props.gid ===
                                  "c1032caf-7739-4567-932d-b0b40050d671" ||
                                this.props.gid ===
                                  "87c8de62-cc9f-4c08-a6f5-b1b200479cfa" ||
                                this.props.gid ===
                                  "0611e452-5776-41dd-8f9a-b12d003f5172" ||
                                this.props.gid ===
                                  "0e6ce08b-0d8f-4853-a131-b28300b87b5d") && (
                                <Fragment>
                                  {botSettings.text.webPoweredBy1}{" "}
                                  <img
                                    src="/res/hospitality_host.png"
                                    width={65}
                                  ></img>
                                </Fragment>
                              )}{" "}
                            </span> */}
                          </div>
                        ) : (
                          <a
                            href={this.props.groupData?.group?.poweredByURL}
                            target="_blank"
                          >
                            <img
                              src={
                                this.props.groupData?.group
                                  ?.poweredByLogoBot === null &&
                                this.props.groupData?.group
                                  ?.poweredByLogoBot === ""
                                  ? this.props.groupData?.group?.poweredByLogo
                                  : this.props.groupData?.group
                                      ?.poweredByLogoBot
                              }
                              style={{ width: "120px" }}
                              alt="Myma Logo"
                            />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}
              </>
            ) : this.props.customStyle !== "" ? (
              <div id="spinner" className="container">
                <div className="loading"></div>
              </div>
            ) : (
              <div className="chat_loading"></div>
            )}
          </div>{" "}
        </Fragment>
      </IntlProvider>
    );
  }
}
